import MachineWarehouseDialog, { canManageWarehouse } from '../../Machines/MachineWarehouseDialog';
import { canCloseDemonstration, findMovementDemonstration } from '../../MachineMovements/Demonstrations/demonstrationClose';
import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { handleGetRequest } from '../../../service/GetTemplate';
import { handleDeleteRequest } from '../../../service/DeleteTemplate';
import { handlePostRequest } from '../../../service/PostTemplate';
import { handlePatchRequest } from '../../../service/PatchTemplate';
import baseURL, { endPoints } from '../../../Config';
import PhotoUploader from '../../../components/PhotoUploader';
import { formatLocalizedDate, formatLocalizedDateTime, formatTimeFromMinutes } from '../../../utilities/formatTime';
import { exportToExcel, exportToCsv } from '../../../utilities/exportToExcel';
import usePreferredLanguage from '../../../utilities/usePreferredLanguage';
import { translateUiText } from '../../../utilities/siteTranslations';
import MachineDemonstrations from '../../MachineMovements/Demonstrations/MachineDemonstrations';
import { getDemonstrations } from '../../MachineMovements/Demonstrations/demonstrationApi';
import { STATUS_META as DEMONSTRATION_STATUS_META } from '../../MachineMovements/Demonstrations/demonstrationConstants';
import SiteInspectionDialog from '../../MachineMovements/SiteInspections/SiteInspectionDialog';
import { getSiteInspections, updateSiteInspection } from '../../MachineMovements/SiteInspections/siteInspectionApi';
import {
    INSPECTION_RESULT_OPTIONS,
    INSPECTION_STATUS_META
} from '../../MachineMovements/SiteInspections/siteInspectionConstants';
import {
    consolidateDemonstrationRows,
    filterRowsByProcess,
    inferMovementWorkflowType,
    isDemonstrationWorkflow,
    isSiteInspectionWorkflow
} from './movementWorkflow';
import {
    filterByInstallationAlert,
    formatInstallationTiming,
    getInstallationAlert,
    INSTALLATION_ALERT_FILTERS,
    INSTALLATION_ALERT_META,
    sortByInstallationPriority
} from './machineMovementSchedule';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './machineMovementReport.css';
import { getCompletedCustomerOptions, filterCompletedMovements, sortCompletedMovements, filterByCompletionRange } from './completedMovementFilters';

const MOVEMENT_TYPES = [
    { label: 'Installation', value: 'Installed' },
    { label: 'Removal', value: 'Removed' },
    { label: 'Exchanged - Installed', value: 'Exchanged - Installed' },
    { label: 'Exchanged - Removed', value: 'Exchanged - Removed' }
];

const MOVEMENT_TYPE_LABELS = {
    Installed: 'Installation',
    Removed: 'Removal',
    'Exchanged - Installed': 'Exchanged - Installed',
    'Exchanged - Removed': 'Exchanged - Removed'
};

const OPEN_MOVEMENT_TYPES = ['Pending', 'In Progress'];
const FINAL_MOVEMENT_TYPES = ['Installed', 'Removed', 'Exchanged - Installed', 'Exchanged - Removed'];
const COMPLETED_MOVEMENTS_PAGE_SIZE = 10;
const PENDING_DEMONSTRATION_STATUSES = [
    'submitted',
    'correction_requested',
    'accepted',
    'preparing',
    'ready_for_commercial_review',
    'commercial_rejected',
    'approved_for_transport',
    'active',
    'pending_pickup',
    'pending_commercial_close'
];
const COMPLETED_DEMONSTRATION_STATUSES = ['closed', 'cancelled'];
const PENDING_SITE_INSPECTION_STATUSES = ['pending', 'in_progress'];
const COMPLETED_SITE_INSPECTION_STATUSES = ['completed', 'cancelled'];
const COMMERCIAL_DEMONSTRATION_ROLES = new Set(['admin', 'superadmin', 'sales', 'seller']);
const DEMONSTRATION_REQUESTER_EMAILS = new Set([
    'lisbeth.velasquez@coffeevending.com.pa',
    'valentina@coffeevending.com.pa'
]);
const PROCESS_FILTER_OPTIONS = [
    { value: 'all', en: 'All processes', es: 'Todos los procesos' },
    { value: 'movements', en: 'Regular movements', es: 'Movimientos regulares' },
    { value: 'demonstrations', en: 'Demonstrations', es: 'Demostraciones' },
    { value: 'inspections', en: 'Site inspections', es: 'Inspecciones de sitio' }
];

const MACHINE_TYPE_OPTIONS = [
    { label: 'Combo', value: 'combo' },
    { label: 'Snack', value: 'snack' },
    { label: 'Drink', value: 'drink' },
    { label: 'Coffee', value: 'coffee' }
];

const PRIORITY_OPTIONS = [
    { value: 'normal', en: 'Normal', es: 'Normal' },
    { value: 'high', en: 'High', es: 'Alta' },
    { value: 'urgent', en: 'Urgent', es: 'Urgente' }
];

const ELECTRICITY_OPTIONS = [
    { value: 'confirmed', en: 'Confirmed', es: 'Confirmada' },
    { value: 'unavailable', en: 'Not available', es: 'No disponible' },
    { value: 'unknown', en: 'Unknown', es: 'Por confirmar' }
];

const VOLTAGE_OPTIONS = [
    { value: '110v', en: '110 V', es: '110 V' },
    { value: '220v', en: '220 V', es: '220 V' },
    { value: 'other', en: 'Other', es: 'Otro' },
    { value: 'unknown', en: 'Unknown', es: 'Por confirmar' },
    { value: 'not_applicable', en: 'Not applicable', es: 'No aplica' }
];

const CONFIRMATION_OPTIONS = [
    { value: 'yes', en: 'Yes', es: 'Sí' },
    { value: 'no', en: 'No', es: 'No' },
    { value: 'unknown', en: 'Unknown', es: 'Por confirmar' },
    { value: 'not_applicable', en: 'Not applicable', es: 'No aplica' }
];

const WATER_OPTIONS = [
    { value: 'water_line', en: 'Water line', es: 'Conexión hídrica' },
    { value: 'bottle', en: 'Water bottle', es: 'Botellón' },
    { value: 'not_applicable', en: 'Not applicable', es: 'No aplica' },
    { value: 'unknown', en: 'Unknown', es: 'Por confirmar' }
];

const CONNECTIVITY_OPTIONS = [
    { value: 'wifi', en: 'Wi-Fi', es: 'Wi-Fi' },
    { value: 'cellular', en: 'Cellular signal', es: 'Señal celular' },
    { value: 'both', en: 'Wi-Fi and cellular', es: 'Wi-Fi y señal celular' },
    { value: 'not_required', en: 'Not required', es: 'No requerida' },
    { value: 'unknown', en: 'Unknown', es: 'Por confirmar' }
];

const YES_NO_UNKNOWN_OPTIONS = [
    { value: 'yes', en: 'Yes', es: 'Sí' },
    { value: 'no', en: 'No', es: 'No' },
    { value: 'unknown', en: 'Unknown', es: 'Por confirmar' }
];

const PAYMENT_METHOD_OPTIONS = [
    { value: 'free', en: 'Free consumption', es: 'Consumo gratuito' },
    { value: 'cash', en: 'Cash', es: 'Efectivo' },
    { value: 'coins', en: 'Coins', es: 'Monedas' },
    { value: 'bills', en: 'Bills', es: 'Billetes' },
    { value: 'card', en: 'Credit/debit card', es: 'Tarjeta' },
    { value: 'yappy', en: 'Yappy', es: 'Yappy' },
    { value: 'qr', en: 'QR code', es: 'Código QR' },
    { value: 'key', en: 'Key', es: 'Llave' },
    { value: 'courtesy_code', en: 'Courtesy code', es: 'Código de cortesía' },
    { value: 'subsidized', en: 'Subsidized', es: 'Subsidiado' },
    { value: 'other', en: 'Other', es: 'Otro' }
];

const ACCESS_FEATURE_OPTIONS = [
    { value: 'parking', en: 'Parking', es: 'Estacionamiento' },
    { value: 'elevator', en: 'Elevator', es: 'Elevador' },
    { value: 'stairs', en: 'Stairs', es: 'Escaleras' },
    { value: 'ramp', en: 'Ramp', es: 'Rampa' },
    { value: 'loading_restrictions', en: 'Loading restrictions', es: 'Restricciones de carga' },
    { value: 'security_registration', en: 'Security registration', es: 'Registro de seguridad' }
];

const INSTALLATION_ACCESSORY_OPTIONS = [
    { value: 'hand_truck', en: 'Hand truck', es: 'Carretilla' },
    { value: 'extension_cord', en: 'Extension cord', es: 'Extensión eléctrica' },
    { value: 'voltage_protector', en: 'Voltage protector', es: 'Protector de voltaje' },
    { value: 'initial_stock', en: 'Initial stock', es: 'Stock inicial' },
    { value: 'furniture', en: 'Furniture or cabinet', es: 'Mueble o gabinete' },
    { value: 'milk_hose', en: 'Milk hose', es: 'Manguera de leche' },
    { value: 'water_bottle', en: 'Water bottle', es: 'Botellón' },
    { value: 'other', en: 'Other', es: 'Otro' }
];

const makeDefaultInstallationDetails = () => ({
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    mapUrl: '',
    specificArea: '',
    accessHours: '',
    accessInstructions: '',
    priority: 'normal',
    estimatedDurationMinutes: null,
    electricityStatus: 'unknown',
    voltage: 'unknown',
    dedicatedOutletStatus: 'unknown',
    waterSupply: 'unknown',
    drainageStatus: 'unknown',
    connectivity: 'unknown',
    telemetryRequired: 'unknown',
    paymentMethods: [],
    accessFeatures: [],
    accessories: [],
    requiresBase: false,
    requiresFridge: false,
    requiresFilter: false,
    requiresPump: false,
    requiresHelper: false,
    initialStockNotes: '',
    specialRequirements: ''
});

const toTitle = (value) => {
    if (!value || typeof value !== 'string') return 'Unknown';
    const normalized = value.trim();
    if (!normalized) return 'Unknown';
    return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
};

const normalizeMachineType = (value) => {
    if (!value || typeof value !== 'string') return '';
    return value.trim().toLowerCase();
};

const resolvePhotoUrl = (value) => {
    if (!value || typeof value !== 'string') return '';
    const trimmed = value.trim();
    if (!trimmed) return '';
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:image')) {
        return trimmed;
    }
    const base = new URL(baseURL || '/api/v1/', window.location.origin).origin + '/';
    return `${base}${trimmed.startsWith('/') ? trimmed.slice(1) : trimmed}`;
};

const resolveSafeWebUrl = (value) => {
    const text = String(value || '').trim();
    return /^https?:\/\//i.test(text) ? text : '';
};

const MAX_CLOSE_PHOTOS = 10;
const MAX_REQUEST_PHOTOS = 10;
const MAX_CHECKLIST_ITEM_PHOTOS = 10;
const MAX_REQUEST_TOTAL_BYTES = 3000 * 1024;
const MAX_CLOSE_TOTAL_BYTES = 3000 * 1024;
const CHECKLIST_ITEM_OPTIONS = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
    { label: 'N/A', value: 'na' }
];

const MARGARITA_ALLOWED_EMAILS = ['operaciones@coffeevending.com.pa'];

const buildMovementRequestId = () =>
    `movement-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

const CHECKLIST_STATUS_LABELS = {
    pending: 'Pending',
    in_progress: 'In Progress',
    ready_to_close: 'Ready to Close',
    closed: 'Closed'
};

const normalizeChecklistValue = (value) => {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'boolean') return value ? 'yes' : 'no';
    return String(value).trim().toLowerCase() || null;
};

const computeChecklistProgress = (checklistData) => {
    const sections = Array.isArray(checklistData?.sections) ? checklistData.sections : [];
    let requiredItems = 0;
    let completedItems = 0;

    sections.forEach((section) => {
        const items = Array.isArray(section?.items) ? section.items : [];
        items.forEach((item) => {
            if (item?.required === false) return;
            requiredItems += 1;
            const value = normalizeChecklistValue(item?.value);
            if (value) completedItems += 1;
        });
    });

    if (!requiredItems) return 100;
    return Math.round((completedItems / requiredItems) * 100);
};

const inferChecklistStatus = (movementType, currentStatus, progress) => {
    if (movementType && FINAL_MOVEMENT_TYPES.includes(movementType)) return 'closed';
    if (currentStatus === 'closed') return 'closed';
    if (progress >= 100) return 'ready_to_close';
    if (progress > 0) return 'in_progress';
    return currentStatus || 'pending';
};

const normalizePhotoList = (singlePhoto, photoList) => {
    const rawPhotos = [];
    if (Array.isArray(photoList)) {
        rawPhotos.push(...photoList);
    }
    if (typeof singlePhoto === 'string' && singlePhoto.trim()) {
        rawPhotos.unshift(singlePhoto);
    }

    const cleaned = rawPhotos
        .filter((photo) => typeof photo === 'string' && photo.trim())
        .map((photo) => photo.trim());

    return cleaned.filter((photo, index) => cleaned.indexOf(photo) === index);
};

const estimateDataUrlSize = (dataUrl) => {
    if (!dataUrl || typeof dataUrl !== 'string') return 0;
    if (!dataUrl.startsWith('data:image')) return 0;
    const parts = dataUrl.split(',');
    if (parts.length < 2) return 0;
    return Math.ceil((parts[1].length * 3) / 4);
};

const toDateOrNull = (value) => {
    if (!value) return null;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatInstallationDateLabel = (from, to, language = 'en') => {
    const start = toDateOrNull(from);
    const end = toDateOrNull(to);
    if (!start && !end) return '-';
    if (start && end) {
        return `${formatLocalizedDate(start, language)} - ${formatLocalizedDate(end, language)}`;
    }
    return formatLocalizedDate(start || end, language);
};

const getDefaultCompletedDateRange = () => {
    const to = new Date();
    to.setHours(23, 59, 59, 999);
    const from = new Date(to.getFullYear(), to.getMonth(), 1);
    from.setHours(0, 0, 0, 0);
    return { from, to };
};

const MachineMovementReport = ({ demonstrationsOnly = false }) => {
    const preferredLanguage = usePreferredLanguage();
    const t = (value) => translateUiText(value, preferredLanguage);
    const [allMovements, setAllMovements] = useState([]);
    const [pendingMovements, setPendingMovements] = useState([]);
    const [completedMovements, setCompletedMovements] = useState([]);
    const [pendingDemonstrations, setPendingDemonstrations] = useState([]);
    const [completedDemonstrations, setCompletedDemonstrations] = useState([]);
    const [pendingSiteInspections, setPendingSiteInspections] = useState([]);
    const [completedSiteInspections, setCompletedSiteInspections] = useState([]);
    const [pendingProcessFilter, setPendingProcessFilter] = useState(
        demonstrationsOnly ? 'demonstrations' : 'all'
    );
    const [installationAlertFilter, setInstallationAlertFilter] = useState('all');
    const [completedProcessFilter, setCompletedProcessFilter] = useState(
        demonstrationsOnly ? 'demonstrations' : 'all'
    );
    const [completedCustomers, setCompletedCustomers] = useState([]);
    const [completedSearch, setCompletedSearch] = useState('');
    const [completedPagination, setCompletedPagination] = useState({
        first: 0,
        page: 1,
        rows: COMPLETED_MOVEMENTS_PAGE_SIZE,
        totalRecords: 0
    });
    const [pendingDateRange, setPendingDateRange] = useState({ from: null, to: null });
    const [installedDateRange, setInstalledDateRange] = useState(() => getDefaultCompletedDateRange());
    const [churnAnalysis, setChurnAnalysis] = useState({
        totalRemovals: 0,
        removalsByReason: []
    });
    const [warehouseMachineId, setWarehouseMachineId] = useState(null);
    const [machines, setMachines] = useState([]);
    const [technicians, setTechnicians] = useState([]);
    const [movementDialogVisible, setMovementDialogVisible] = useState(false);
    const [closeDialogVisible, setCloseDialogVisible] = useState(false);
    const [viewDialogVisible, setViewDialogVisible] = useState(false);
    const [photoDialogVisible, setPhotoDialogVisible] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState('');
    const [selectedPhotoError, setSelectedPhotoError] = useState(false);
    const [selectedMovement, setSelectedMovement] = useState(null);
    const [selectedMovementLoading, setSelectedMovementLoading] = useState(false);
    const [movementForm, setMovementForm] = useState({
        technicianId: '',
        customer: '',
        machineId: '',
        machineType: '',
        movementType: '',
        fromLocation: '',
        toLocation: '',
        installationDateRange: null,
        installationDetails: makeDefaultInstallationDetails(),
        requestPhotos: [],
        comments: '',
        clientRequestId: buildMovementRequestId(),
        siteInspectionId: ''
    });
    const [closeForm, setCloseForm] = useState({
        movementId: '',
        finalMovementType: 'Installed',
        machineId: '',
        machineType: '',
        completionComments: '',
        completionPhotos: [],
        installationConfirmed: false
    });
    const [checklistDialogVisible, setChecklistDialogVisible] = useState(false);
    const [checklistLoading, setChecklistLoading] = useState(false);
    const [checklistSaving, setChecklistSaving] = useState(false);
    const [checklistForm, setChecklistForm] = useState(null);
    const [movementSaving, setMovementSaving] = useState(false);
    const demonstrationControllerRef = useRef(null);
    const siteInspectionControllerRef = useRef(null);
    const createMenuRef = useRef(null);

    const dispatch = useDispatch();
    const currentUser = JSON.parse(localStorage.getItem('userDetails') || '{}');
    const currentAdmin = currentUser?.data?.adminUser || {};
    const normalizePermissionToken = (value) =>
        String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, '');
    const currentRoleToken = normalizePermissionToken(
        currentAdmin?.role?.uid ||
        currentAdmin?.role?.title ||
        currentAdmin?.roleUid ||
        currentUser?.data?.role?.uid ||
        currentUser?.data?.role?.title ||
        currentUser?.role?.uid ||
        currentUser?.role?.title
    );
    const currentUserEmail = String(
        currentAdmin?.email ||
        currentAdmin?.user?.email ||
        currentUser?.data?.email ||
        currentUser?.email ||
        ''
    ).trim().toLowerCase();
    const movementTypeOptions = MOVEMENT_TYPES.map((item) => ({ ...item, label: t(item.label) }));
    const machineTypeOptions = MACHINE_TYPE_OPTIONS.map((item) => ({ ...item, label: t(item.label) }));
    const checklistItemOptions = CHECKLIST_ITEM_OPTIONS.map((item) => ({ ...item, label: t(item.label) }));
    const localText = (english, spanish) => preferredLanguage === 'es' ? spanish : english;
    const localizeOptions = (options) => options.map((option) => ({
        value: option.value,
        label: preferredLanguage === 'es' ? option.es : option.en
    }));
    const getLocalizedOptionLabel = (options, value) =>
        localizeOptions(options).find((option) => option.value === value)?.label || value || '-';
    const getLocalizedOptionList = (options, values) =>
        (Array.isArray(values) ? values : [])
            .map((value) => getLocalizedOptionLabel(options, value))
            .join(', ') || '-';
    const getInstallationRequirementList = (details = {}) => [
        details.requiresBase && localText('Base or stand', 'Base o soporte'),
        details.requiresFridge && localText('Cooling fridge', 'Nevera enfriadora'),
        details.requiresFilter && localText('Water filter', 'Filtro de agua'),
        details.requiresPump && localText('Water pump', 'Bomba de agua'),
        details.requiresHelper && localText('Loading helper', 'Ayudante de carga')
    ].filter(Boolean).join(', ') || '-';
    const priorityOptions = localizeOptions(PRIORITY_OPTIONS);
    const electricityOptions = localizeOptions(ELECTRICITY_OPTIONS);
    const voltageOptions = localizeOptions(VOLTAGE_OPTIONS);
    const confirmationOptions = localizeOptions(CONFIRMATION_OPTIONS);
    const waterOptions = localizeOptions(WATER_OPTIONS);
    const connectivityOptions = localizeOptions(CONNECTIVITY_OPTIONS);
    const yesNoUnknownOptions = localizeOptions(YES_NO_UNKNOWN_OPTIONS);
    const paymentMethodOptions = localizeOptions(PAYMENT_METHOD_OPTIONS);
    const accessFeatureOptions = localizeOptions(ACCESS_FEATURE_OPTIONS);
    const installationAccessoryOptions = localizeOptions(INSTALLATION_ACCESSORY_OPTIONS);
    const processFilterOptions = localizeOptions(PROCESS_FILTER_OPTIONS);
    const isNormalInstallation = movementForm.movementType === 'Installed';
    const movementMachineOptions = isNormalInstallation
        ? machines.filter((machine) => machine.inStockInventory === true)
        : machines;
    const canDeletePendingMovements =
        ['admin', 'superadmin'].includes(currentRoleToken) ||
        MARGARITA_ALLOWED_EMAILS.includes(currentUserEmail);
    const canCreateDemonstration =
        COMMERCIAL_DEMONSTRATION_ROLES.has(currentRoleToken) ||
        DEMONSTRATION_REQUESTER_EMAILS.has(currentUserEmail);
    const canCreateSiteInspection =
        !demonstrationsOnly &&
        ['admin', 'superadmin', 'support', 'technician'].includes(currentRoleToken);

    const loadMachines = async () => {
        const response = await handleGetRequest(`${endPoints.getallMachine}?summary=true`, true, false, dispatch);
        if (response?.data) {
            const options = response.data
                .map((m) => ({
                    _id: m._id || m.id,
                    type: (m.type || '').toLowerCase(),
                    inStockInventory: m.inStockInventory === true,
                    location: m.location || '',
                    label: [
                        m.machine || m.name || 'Unnamed Machine',
                        toTitle(m.type) || 'Unknown Type',
                        m.inStockInventory === true ? t('In Stock') : 'Fuera de inventario',
                        m.location || (m.inStockInventory === true ? 'Warehouse' : 'No Location'),
                        m.serialNumber || m.deviceId || m.uuid || 'No ID'
                    ].join(' - ')
                }));
            setMachines(options);
        }
    };

    const loadTechnicians = async () => {
        const response = await handleGetRequest(endPoints.getTechnicians, true, false, dispatch);
        if (response?.data) {
            const options = response.data.map((t) => ({
                _id: t._id || t.id,
                label: `${t.firstName || ''} ${t.lastName || ''}`.trim() || t.email || 'Unknown Technician'
            }));
            setTechnicians(options);
        }
    };

    const normalizeMovementRecord = (m) => {
        const machineObj = m.machine && typeof m.machine === 'object' ? m.machine : null;
        const machineTypeRaw = normalizeMachineType(m.machineType || machineObj?.type || '');

        return {
            _id: m._id,
            id: m._id,
            machineId: machineObj?.serialNumber || machineObj?.deviceId || '-',
            machineRefId: machineObj?._id || (typeof m.machine === 'string' ? m.machine : ''),
            machineType:
                machineTypeRaw
                    ? toTitle(machineTypeRaw)
                    : machineObj?.model || machineObj?.machine || '-',
            machineTypeValue: machineTypeRaw,
            movementType: m.movementType,
            date: m.createdAt ? new Date(m.createdAt).toISOString().split('T')[0] : '',
            fromLocation: m.fromLocation || 'Warehouse',
            toLocation: m.toLocation || m.location || '',
            installationDateFrom: m.installationDateFrom || null,
            installationDateTo: m.installationDateTo || null,
            installationDetails: m.installationDetails || null,
            reason: m.reasonForRemoval || '',
            customer: m.customer || '',
            technician: m.technician ? `${m.technician.firstName || ''} ${m.technician.lastName || ''}`.trim() : '-',
            requestedBy:
                m.createdBy
                    ? `${m.createdBy.firstName || ''} ${m.createdBy.lastName || ''}`.trim() || m.createdBy.email || '-'
                    : '-',
            auditTimeline: [],
            requestedMovementType:
                m.requestedMovementType ||
                (OPEN_MOVEMENT_TYPES.includes(m.movementType) ? 'Installed' : m.movementType),
            checklistTemplateKey: m.checklistTemplateKey || null,
            checklistStatus: m.checklistStatus || null,
            checklistProgress: typeof m.checklistProgress === 'number' ? m.checklistProgress : 0,
            photo: m.photo || '',
            requestPhotos: normalizePhotoList(m.photo, m.requestPhotos),
            comments: m.comments || '',
            completionComments: m.completionComments || '',
            completionPhoto: m.completionPhoto || '',
            completionPhotos: normalizePhotoList(m.completionPhoto, m.completionPhotos),
            completedAt: m.completedAt || null,
            actualInstallationAt: m.actualInstallationAt || null,
            workflowType: inferMovementWorkflowType(
                m.workflowType,
                m.clientRequestId
            ),
            clientRequestId: m.clientRequestId || '',
            isDemonstration: false,
            completedBy:
                m.completedBy
                    ? `${m.completedBy.firstName || ''} ${m.completedBy.lastName || ''}`.trim() || m.completedBy.email || '-'
                    : '-',
            createdAt: m.createdAt,
            raw: m
        };
    };

    const normalizeMovementListResponse = (response) => {
        const payload = response?.data;
        const rawList = Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload)
                ? payload
                : [];

        return {
            list: rawList.map(normalizeMovementRecord),
            pagination: payload?.pagination || null
        };
    };

    const appendSharedMovementParams = (params) => {
        if (currentRoleToken === 'technician' && currentAdmin?._id) {
            params.append('technicianId', currentAdmin._id);
        }
    };

    const appendDateRangeParams = (params, range) => {
        if (range?.from) {
            params.append('from', range.from.toISOString());
        }
        if (range?.to) {
            const toDate = new Date(range.to);
            toDate.setHours(23, 59, 59, 999);
            params.append('to', toDate.toISOString());
        }
    };

    const getPersonName = (person) => {
        if (!person) return '-';
        return `${person.firstName || ''} ${person.lastName || ''}`.trim() || person.email || '-';
    };

    const normalizeDemonstrationRecord = (demonstration) => {
        const machine = demonstration.assignedMachine || {};
        const completedBy = demonstration.status === 'cancelled'
            ? demonstration.cancelledBy
            : demonstration.closedBy;
        const statusMeta = DEMONSTRATION_STATUS_META[demonstration.status] || {};
        return {
            _id: `demo:${demonstration._id}`,
            id: `demo:${demonstration._id}`,
            demonstrationId: demonstration._id,
            requestNumber: demonstration.requestNumber,
            machineId: machine.serialNumber || machine.deviceId || '-',
            machineRefId: machine._id || '',
            machineType: toTitle(
                machine.type || demonstration.machineRequest?.type || 'Demostración'
            ),
            machineTypeValue: normalizeMachineType(
                machine.type || demonstration.machineRequest?.type || ''
            ),
            movementType: 'Demonstration',
            requestedMovementType: 'Demonstration',
            date: demonstration.createdAt
                ? new Date(demonstration.createdAt).toISOString().split('T')[0]
                : '',
            fromLocation: 'Taller',
            toLocation: demonstration.client?.address || '',
            installationDateFrom: demonstration.schedule?.installationAt || null,
            installationDateTo: demonstration.schedule?.pickupAt || null,
            installationDetails: {
                contactName: demonstration.client?.contactName || '',
                contactPhone: demonstration.client?.contactPhone || '',
                contactEmail: demonstration.client?.contactEmail || '',
                mapUrl: demonstration.client?.mapUrl || '',
                specificArea: demonstration.client?.office || '',
                accessInstructions: demonstration.schedule?.accessInstructions || '',
                priority: demonstration.priority || 'normal',
                waterSupply: demonstration.machineRequest?.waterSupply || 'unknown',
                paymentMethods: demonstration.machineRequest?.paymentMethods || [],
                accessories: demonstration.accessories || [],
                specialRequirements: demonstration.machineRequest?.specialRequests || ''
            },
            reason: '',
            customer: demonstration.client?.name || '',
            technician: getPersonName(demonstration.assignedTechnician),
            requestedBy: getPersonName(demonstration.createdBy),
            checklistTemplateKey:
                demonstration.installationMovement?.checklistTemplateKey || null,
            checklistStatus:
                demonstration.installationMovement?.checklistStatus || null,
            checklistProgress:
                Number(demonstration.installationMovement?.checklistProgress || 0),
            comments: demonstration.objectiveDetails || '',
            completionComments: demonstration.feedback?.customerComments || '',
            completedAt:
                demonstration.closedAt || demonstration.cancelledAt || null,
            completedBy: getPersonName(completedBy),
            createdAt: demonstration.createdAt,
            demoStatus: demonstration.status,
            demoStatusLabel: statusMeta.label || demonstration.status,
            workflowType: 'demonstration',
            clientRequestId: demonstration.requestNumber,
            isDemonstration: true,
            rawDemo: demonstration
        };
    };

    const normalizeSiteInspectionRecord = (inspection) => {
        const statusMeta = INSPECTION_STATUS_META[inspection.status] || INSPECTION_STATUS_META.pending;
        const plannedType = normalizeMachineType(inspection.plannedEquipment?.machineType || '');
        const completedBy = getPersonName(inspection.completedBy);
        return {
            _id: `inspection:${inspection._id}`,
            id: `inspection:${inspection._id}`,
            siteInspectionId: inspection._id,
            inspectionNumber: inspection.inspectionNumber,
            machineId: '-',
            machineRefId: '',
            machineType: plannedType
                ? toTitle(plannedType)
                : localText('Not assigned', 'Sin equipo asignado'),
            machineTypeValue: plannedType,
            movementType: 'Site Inspection',
            requestedMovementType: 'Site Inspection',
            date: inspection.scheduledAt
                ? new Date(inspection.scheduledAt).toISOString().split('T')[0]
                : '',
            fromLocation: '',
            toLocation: [inspection.client?.locationName, inspection.client?.address]
                .filter(Boolean)
                .join(' · '),
            installationDateFrom: inspection.scheduledAt || null,
            installationDateTo: inspection.scheduledAt || null,
            installationDetails: {
                contactName: inspection.client?.contactName || '',
                contactPhone: inspection.client?.contactPhone || '',
                mapUrl: inspection.client?.mapUrl || '',
                specificArea: inspection.client?.specificArea || '',
                accessInstructions: inspection.accessInstructions || ''
            },
            customer: inspection.client?.name || '',
            technician: inspection.assignedTechnician
                ? getPersonName(inspection.assignedTechnician)
                : localText('Unassigned', 'Por asignar'),
            requestedBy: getPersonName(inspection.createdBy),
            checklistTemplateKey: 'site_inspection',
            checklistStatus: inspection.status,
            checklistProgress: Number(inspection.checklistProgress || 0),
            comments: inspection.overallNotes || '',
            completionComments: inspection.adjustmentSummary || '',
            completedAt: inspection.completedAt || null,
            completedBy,
            createdAt: inspection.createdAt,
            inspectionStatus: inspection.status,
            inspectionStatusLabel: preferredLanguage === 'es' ? statusMeta.es : statusMeta.en,
            inspectionResult: inspection.result,
            workflowType: 'site_inspection',
            isSiteInspection: true,
            isDemonstration: false,
            rawInspection: inspection
        };
    };

    const fetchAllDemonstrations = async (statuses, range) => {
        const makeParams = (page) => {
            const params = new URLSearchParams();
            params.set('status', statuses.join(','));
            params.set('limit', '100');
            params.set('page', String(page));
            appendDateRangeParams(params, range);
            return params;
        };

        const firstResponse = await getDemonstrations(makeParams(1).toString(), dispatch);
        const firstData = firstResponse?.data;
        const firstItems = Array.isArray(firstData?.items) ? firstData.items : [];
        const total = Number(firstData?.total || firstItems.length);
        const pageCount = Math.ceil(total / 100);
        if (pageCount <= 1) return firstItems;

        const remainingResponses = await Promise.all(
            Array.from({ length: pageCount - 1 }, (_, index) =>
                getDemonstrations(makeParams(index + 2).toString(), dispatch)
            )
        );
        return remainingResponses.reduce((items, response) => {
            const pageItems = Array.isArray(response?.data?.items)
                ? response.data.items
                : [];
            return items.concat(pageItems);
        }, firstItems);
    };

    const loadDemonstrationWorkflows = async () => {
        const [pending, completed] = await Promise.all([
            fetchAllDemonstrations(PENDING_DEMONSTRATION_STATUSES, pendingDateRange),
            fetchAllDemonstrations(COMPLETED_DEMONSTRATION_STATUSES, null)
        ]);
        setPendingDemonstrations(pending.map(normalizeDemonstrationRecord));
        setCompletedDemonstrations(filterByCompletionRange(completed.map(normalizeDemonstrationRecord), installedDateRange));
        return { pending, completed };
    };

    const fetchAllSiteInspections = async (statuses, range) => {
        const makeParams = (page) => {
            const params = new URLSearchParams();
            params.set('status', statuses.join(','));
            params.set('limit', '100');
            params.set('page', String(page));
            appendDateRangeParams(params, range);
            return params;
        };
        const firstResponse = await getSiteInspections(makeParams(1).toString(), dispatch);
        const firstData = firstResponse?.data;
        const firstItems = Array.isArray(firstData?.items) ? firstData.items : [];
        const total = Number(firstData?.total || firstItems.length);
        const pageCount = Math.ceil(total / 100);
        if (pageCount <= 1) return firstItems;
        const remainingResponses = await Promise.all(
            Array.from({ length: pageCount - 1 }, (_, index) =>
                getSiteInspections(makeParams(index + 2).toString(), dispatch)
            )
        );
        return remainingResponses.reduce((items, response) =>
            items.concat(Array.isArray(response?.data?.items) ? response.data.items : []), firstItems);
    };

    const loadSiteInspectionWorkflows = async () => {
        if (demonstrationsOnly) return { pending: [], completed: [] };
        const [pending, completed] = await Promise.all([
            fetchAllSiteInspections(PENDING_SITE_INSPECTION_STATUSES, pendingDateRange),
            fetchAllSiteInspections(COMPLETED_SITE_INSPECTION_STATUSES, null)
        ]);
        setPendingSiteInspections(pending.map(normalizeSiteInspectionRecord));
        setCompletedSiteInspections(filterByCompletionRange(completed.map(normalizeSiteInspectionRecord), installedDateRange));
        return { pending, completed };
    };

    const updateMovementCollections = (pendingList, completedList) => {
        const combined = [...pendingList, ...completedList];
        setAllMovements(combined);

        const removals = completedList.filter(
            (m) =>
                m.movementType === 'Removed' &&
                m.workflowType !== 'demo_pickup'
        );
        const removalsByReason = {};
        removals.forEach((r) => {
            const key = r.reason || 'Other';
            removalsByReason[key] = (removalsByReason[key] || 0) + 1;
        });

        setChurnAnalysis({
            totalRemovals: removals.length,
            removalsByReason: Object.entries(removalsByReason).map(([reason, count]) => ({
                reason,
                count
            }))
        });
    };

    const loadPendingMovements = async () => {
        if (demonstrationsOnly) {
            setPendingMovements([]);
            return [];
        }
        const params = new URLSearchParams();
        params.append('statusGroup', 'pending');
        appendSharedMovementParams(params);
        appendDateRangeParams(params, pendingDateRange);

        const response = await handleGetRequest(endPoints.getMachineMovements(params.toString()), true, false, dispatch);
        if (!response?.data) return [];

        const { list } = normalizeMovementListResponse(response);
        setPendingMovements(list);
        return list;
    };

    const loadCompletedMovements = async () => {
        if (demonstrationsOnly) {
            setCompletedMovements([]);
            setCompletedPagination((current) => ({ ...current, totalRecords: 0 }));
            return [];
        }
        const params = new URLSearchParams();
        params.append('statusGroup', 'completed');
        appendSharedMovementParams(params);
        appendDateRangeParams(params, installedDateRange);

        const response = await handleGetRequest(endPoints.getMachineMovements(params.toString()), true, false, dispatch);
        if (!response?.data) return [];

        const { list } = normalizeMovementListResponse(response);
        setCompletedMovements(list);
        setCompletedPagination((current) => ({
            ...current,
            totalRecords: list.length
        }));
        return list;
    };

    const loadMovements = async () => {
        await Promise.all([
            loadPendingMovements(),
            loadCompletedMovements(),
            loadDemonstrationWorkflows(),
            loadSiteInspectionWorkflows()
        ]);
    };

    useEffect(() => {
        if (!demonstrationsOnly) {
            loadMachines();
            loadTechnicians();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        loadPendingMovements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingDateRange]);

    useEffect(() => {
        loadCompletedMovements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [installedDateRange, demonstrationsOnly]);

    useEffect(() => {
        loadDemonstrationWorkflows();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingDateRange, installedDateRange]);

    useEffect(() => {
        loadSiteInspectionWorkflows();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingDateRange, installedDateRange, demonstrationsOnly]);

    useEffect(() => {
        updateMovementCollections(pendingMovements, completedMovements);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingMovements, completedMovements]);

    useEffect(() => {
        if (!selectedMovement?._id) return;
        const refreshed = allMovements.find((item) => item._id === selectedMovement._id);
        if (refreshed) {
            setSelectedMovement(refreshed);
        }
    }, [allMovements, selectedMovement?._id]);

    const sortByScheduledDate = (rows) => sortByInstallationPriority(rows);

    const knownDemonstrations = [
        ...pendingDemonstrations,
        ...completedDemonstrations
    ];
    const allPendingRows = consolidateDemonstrationRows(
        [...pendingMovements, ...pendingDemonstrations, ...pendingSiteInspections],
        knownDemonstrations
    );
    const allCompletedRows = consolidateDemonstrationRows(
        [...completedMovements, ...completedDemonstrations, ...completedSiteInspections],
        knownDemonstrations
    );
    const processFilteredPendingRows = filterRowsByProcess(
        sortByScheduledDate(allPendingRows),
        pendingProcessFilter
    );
    const installationAlertCounts = INSTALLATION_ALERT_FILTERS.reduce((counts, code) => {
        counts[code] = code === 'all'
            ? processFilteredPendingRows.length
            : processFilteredPendingRows.filter((row) => getInstallationAlert(row).code === code).length;
        return counts;
    }, {});
    const pendingTableRows = filterByInstallationAlert(
        processFilteredPendingRows,
        installationAlertFilter
    );
    const completedCustomerOptions = getCompletedCustomerOptions(allCompletedRows, completedCustomers);
    const completedTableRows = filterCompletedMovements(
        filterRowsByProcess(sortCompletedMovements(allCompletedRows), completedProcessFilter),
        completedCustomers,
        completedSearch
    );
    const activeDemonstrations = pendingDemonstrations.filter(
        (row) => row.demoStatus === 'active'
    ).length;

    const openCloseDialog = (rowData) => {
        setCloseForm({
            movementId: rowData._id,
            finalMovementType: rowData.requestedMovementType || 'Installed',
            machineId: rowData.machineRefId || '',
            machineType: rowData.machineTypeValue || '',
            completionComments: rowData.completionComments || '',
            completionPhotos: normalizePhotoList(rowData.completionPhoto, rowData.completionPhotos),
            installationConfirmed: false
        });
        setCloseDialogVisible(true);
    };

    const getChecklistDisplay = (rowData) => {
        if (!rowData?.checklistTemplateKey) return t('N/A');
        const progress = typeof rowData.checklistProgress === 'number' ? rowData.checklistProgress : 0;
        const status = CHECKLIST_STATUS_LABELS[rowData.checklistStatus] || CHECKLIST_STATUS_LABELS[inferChecklistStatus(rowData?.movementType, rowData?.checklistStatus, progress)] || 'Pending';
        return `${t(status)} (${progress}%)`;
    };

    const isInstallationCloseType = (movementType) =>
        movementType === 'Installed' || movementType === 'Exchanged - Installed';

    const isChecklistBlockingClose = (rowData) => {
        if (!rowData || !OPEN_MOVEMENT_TYPES.includes(rowData.movementType)) return false;
        if (!rowData.checklistTemplateKey) return false;
        const progress = typeof rowData.checklistProgress === 'number' ? rowData.checklistProgress : 0;
        return progress < 100;
    };

    const loadChecklist = async (movementId, showLoader = true) => {
        if (!movementId) return null;
        if (showLoader) setChecklistLoading(true);
        try {
            const response = await handleGetRequest(endPoints.getMovementChecklist(movementId), true, false, dispatch);
            return response?.data || null;
        } catch (error) {
            console.error('Error loading checklist:', error);
            return null;
        } finally {
            if (showLoader) setChecklistLoading(false);
        }
    };

    const openChecklistDialog = async (rowData) => {
        if (!rowData?._id) return;
        const checklistPayload = await loadChecklist(rowData._id, true);
        if (!checklistPayload) return;
        if (!checklistPayload.checklistTemplateKey || !checklistPayload.checklistData) {
            toast.info(t('This movement does not have a checklist template.'));
            return;
        }

        const localProgress = computeChecklistProgress(checklistPayload.checklistData);
        const localStatus = inferChecklistStatus(
            rowData.movementType,
            checklistPayload.checklistStatus,
            localProgress
        );

        setChecklistForm({
            movementId: rowData._id,
            movementType: rowData.movementType,
            checklistTemplateKey: checklistPayload.checklistTemplateKey,
            checklistStatus: localStatus,
            checklistProgress: localProgress,
            checklistData: checklistPayload.checklistData
        });
        setChecklistDialogVisible(true);
    };

    const updateChecklistGeneralInfo = (field, value) => {
        setChecklistForm((prev) => {
            if (!prev?.checklistData) return prev;
            return {
                ...prev,
                checklistData: {
                    ...prev.checklistData,
                    generalInfo: {
                        ...(prev.checklistData.generalInfo || {}),
                        [field]: value
                    }
                }
            };
        });
    };

    const updateChecklistSectionNotes = (sectionKey, notes) => {
        setChecklistForm((prev) => {
            if (!prev?.checklistData) return prev;
            const nextSections = (prev.checklistData.sections || []).map((section) =>
                section.sectionKey === sectionKey ? { ...section, notes } : section
            );
            return {
                ...prev,
                checklistData: { ...prev.checklistData, sections: nextSections }
            };
        });
    };

    const updateChecklistItem = (sectionKey, itemKey, patch) => {
        setChecklistForm((prev) => {
            if (!prev?.checklistData) return prev;
            const nextSections = (prev.checklistData.sections || []).map((section) => {
                if (section.sectionKey !== sectionKey) return section;
                return {
                    ...section,
                    items: (section.items || []).map((item) =>
                        item.itemKey === itemKey ? { ...item, ...patch } : item
                    )
                };
            });
            const nextData = { ...prev.checklistData, sections: nextSections };
            const nextProgress = computeChecklistProgress(nextData);
            const nextStatus = inferChecklistStatus(prev.movementType, prev.checklistStatus, nextProgress);
            return {
                ...prev,
                checklistData: nextData,
                checklistProgress: nextProgress,
                checklistStatus: nextStatus
            };
        });
    };

    const buildChecklistUpdatePayload = (state) => {
        if (!state?.checklistData) return null;
        return {
            status: inferChecklistStatus(state.movementType, state.checklistStatus, state.checklistProgress),
            generalInfo: state.checklistData.generalInfo || {},
            sections: (state.checklistData.sections || []).map((section) => ({
                sectionKey: section.sectionKey,
                notes: section.notes || '',
                items: (section.items || []).map((item) => ({
                    itemKey: item.itemKey,
                    value: normalizeChecklistValue(item.value),
                    note: item.note || '',
                    photos: Array.isArray(item.photos) ? item.photos : []
                }))
            })),
            finalAssessment: state.checklistData.finalAssessment || {},
            signatures: state.checklistData.signatures || {}
        };
    };

    const saveChecklist = async () => {
        if (!checklistForm?.movementId) return;
        const payload = buildChecklistUpdatePayload(checklistForm);
        if (!payload) return;

        setChecklistSaving(true);
        try {
            const response = await dispatch(
                handlePatchRequest(payload, endPoints.updateMovementChecklist(checklistForm.movementId), true, true)
            );
            if (response?.status === 200) {
                const updated = response?.data?.data || null;
                setChecklistForm((prev) => {
                    if (!prev || !updated) return prev;
                    return {
                        ...prev,
                        checklistStatus: updated.checklistStatus || prev.checklistStatus,
                        checklistProgress:
                            typeof updated.checklistProgress === 'number'
                                ? updated.checklistProgress
                                : prev.checklistProgress,
                        checklistData: updated.checklistData || prev.checklistData
                    };
                });
                await loadMovements();
            }
        } catch (error) {
            console.error('Error saving checklist:', error);
        } finally {
            setChecklistSaving(false);
        }
    };

    const addChecklistItemPhoto = (sectionKey, itemKey, photoValue) => {
        if (!photoValue || typeof photoValue !== 'string') return;
        setChecklistForm((prev) => {
            if (!prev?.checklistData) return prev;
            const nextSections = (prev.checklistData.sections || []).map((section) => {
                if (section.sectionKey !== sectionKey) return section;
                return {
                    ...section,
                    items: (section.items || []).map((item) => {
                        if (item.itemKey !== itemKey) return item;
                        const nextPhotos = normalizePhotoList(null, [...(item.photos || []), photoValue]).slice(
                            0,
                            MAX_CHECKLIST_ITEM_PHOTOS
                        );
                        return { ...item, photos: nextPhotos };
                    })
                };
            });
            return {
                ...prev,
                checklistData: { ...prev.checklistData, sections: nextSections }
            };
        });
    };

    const removeChecklistItemPhoto = (sectionKey, itemKey, photoIndex) => {
        setChecklistForm((prev) => {
            if (!prev?.checklistData) return prev;
            const nextSections = (prev.checklistData.sections || []).map((section) => {
                if (section.sectionKey !== sectionKey) return section;
                return {
                    ...section,
                    items: (section.items || []).map((item) => {
                        if (item.itemKey !== itemKey) return item;
                        return {
                            ...item,
                            photos: (item.photos || []).filter((_, index) => index !== photoIndex)
                        };
                    })
                };
            });
            return {
                ...prev,
                checklistData: { ...prev.checklistData, sections: nextSections }
            };
        });
    };

    const getTotalClosePhotoBytes = (photos = []) =>
        photos.reduce((sum, photo) => sum + estimateDataUrlSize(photo), 0);

    const getTotalRequestPhotoBytes = (photos = []) =>
        photos.reduce((sum, photo) => sum + estimateDataUrlSize(photo), 0);

    const addRequestPhoto = (photoValue) => {
        if (!photoValue || typeof photoValue !== 'string') return;
        setMovementForm((prev) => {
            if (prev.requestPhotos.length >= MAX_REQUEST_PHOTOS) {
                toast.warn(t('Maximum 10 photos allowed.'));
                return prev;
            }

            const nextPhotos = normalizePhotoList(null, [...prev.requestPhotos, photoValue]);
            if (nextPhotos.length > MAX_REQUEST_PHOTOS) {
                toast.warn(t('Maximum 10 photos allowed.'));
                return prev;
            }

            const totalBytes = getTotalRequestPhotoBytes(nextPhotos);
            if (totalBytes > MAX_REQUEST_TOTAL_BYTES) {
                toast.warn(t('Total photo size limit reached. Remove one photo or upload smaller images.'));
                return prev;
            }

            return {
                ...prev,
                requestPhotos: nextPhotos
            };
        });
    };

    const addClosePhoto = (photoValue) => {
        if (!photoValue || typeof photoValue !== 'string') return;
        setCloseForm((prev) => {
            if (prev.completionPhotos.length >= MAX_CLOSE_PHOTOS) {
                toast.warn(t('Maximum 10 photos allowed.'));
                return prev;
            }

            const nextPhotos = normalizePhotoList(null, [...prev.completionPhotos, photoValue]);
            if (nextPhotos.length > MAX_CLOSE_PHOTOS) {
                toast.warn(t('Maximum 10 photos allowed.'));
                return prev;
            }

            const totalBytes = getTotalClosePhotoBytes(nextPhotos);
            if (totalBytes > MAX_CLOSE_TOTAL_BYTES) {
                toast.warn(t('Total photo size limit reached. Remove one photo or upload smaller images.'));
                return prev;
            }

            return {
                ...prev,
                completionPhotos: nextPhotos
            };
        });
    };

    const submitCloseMovement = async () => {
        if (!closeForm.movementId) return;
        const movementToClose = allMovements.find((item) => item._id === closeForm.movementId);
        if (isChecklistBlockingClose(movementToClose)) {
            toast.warn(t('Complete the checklist before closing this movement.'));
            return;
        }
        const finalMovementType = closeForm.finalMovementType || movementToClose?.requestedMovementType || 'Installed';
        if (isInstallationCloseType(finalMovementType) && !closeForm.installationConfirmed) {
            toast.warn(localText(
                'Confirm that the machine was physically installed before closing.',
                'Confirme que la máquina fue instalada físicamente antes de cerrar.'
            ));
            return;
        }
        try {
            const closePhotos = normalizePhotoList(null, closeForm.completionPhotos).slice(0, MAX_CLOSE_PHOTOS);
            const response = await dispatch(
                handlePatchRequest(
                    {
                        movementType: finalMovementType,
                        installationConfirmed: isInstallationCloseType(finalMovementType)
                            ? closeForm.installationConfirmed
                            : undefined,
                        machineId: closeForm.machineId || null,
                        machineType: closeForm.machineType || null,
                        completionComments: closeForm.completionComments,
                        completionPhotos: closePhotos,
                        completionPhoto: closePhotos[0] || null
                    },
                    endPoints.updateMovementStatus(closeForm.movementId),
                    true
                )
            );
            if (response?.status === 200) {
                setCloseDialogVisible(false);
                resetCompletedPage();
                await loadMovements();
            }
        } catch (error) {
            console.error('Error updating status:', error);
        }
    };

    const movementTypeBodyTemplate = (rowData) => {
        if (rowData.isSiteInspection) {
            const resultMeta = INSPECTION_RESULT_OPTIONS.find(
                (option) => option.value === rowData.inspectionResult
            );
            return (
                <div className="flex flex-column gap-1 align-items-start">
                    <span className="movement-table-status movement-status-purple">
                        {localText('Site inspection', 'Inspección de sitio')}
                    </span>
                    <small className="text-500">
                        {rowData.inspectionStatus === 'completed' && resultMeta
                            ? (preferredLanguage === 'es' ? resultMeta.es : resultMeta.en)
                            : rowData.inspectionStatusLabel}
                    </small>
                </div>
            );
        }
        if (rowData.isDemonstration) {
            return (
                <div className="flex flex-column gap-1 align-items-start">
                    <span className="movement-table-status movement-status-blue">
                        {localText('Demonstration', 'Demostración')}
                    </span>
                    <small className="text-500">{rowData.demoStatusLabel}</small>
                </div>
            );
        }
        if (rowData.workflowType === 'demo_installation') {
            return (
                <span className="movement-table-status movement-status-blue">
                    {localText(
                        'Temporary demonstration installation',
                        'Instalación temporal de demostración'
                    )}
                </span>
            );
        }
        if (rowData.workflowType === 'demo_pickup') {
            return (
                <span className="movement-table-status movement-status-amber">
                    {localText(
                        'Demonstration pickup',
                        'Retiro de demostración'
                    )}
                </span>
            );
        }
        const typeTones = {
            Installed: 'success',
            Removed: 'danger',
            'Exchanged - Installed': 'amber',
            'Exchanged - Removed': 'amber',
            Pending: 'neutral',
            'In Progress': 'blue'
        };
        const label =
            OPEN_MOVEMENT_TYPES.includes(rowData.movementType)
                ? `${t(rowData.movementType)} (${t(MOVEMENT_TYPE_LABELS[rowData.requestedMovementType] || rowData.requestedMovementType || 'Installation')})`
                : t(rowData.movementType);
        return (
            <span className={`movement-table-status movement-status-${typeTones[rowData.movementType] || 'blue'}`}>
                {label}
            </span>
        );
    };

    const checklistStatusBodyTemplate = (rowData) => {
        if (rowData?.isSiteInspection) {
            const progress = Number(rowData.checklistProgress || 0);
            const tone = rowData.inspectionStatus === 'completed'
                ? 'success'
                : progress > 0
                    ? 'amber'
                    : 'neutral';
            return (
                <span className={`movement-table-status movement-status-${tone}`}>
                    {rowData.inspectionStatusLabel} ({progress}%)
                </span>
            );
        }
        if (rowData?.isDemonstration && !rowData.checklistTemplateKey) {
            return <span className="text-500">{rowData.demoStatusLabel}</span>;
        }
        if (!rowData?.checklistTemplateKey) return <span className="text-500">{t('N/A')}</span>;
        const progress = typeof rowData.checklistProgress === 'number' ? rowData.checklistProgress : 0;
        const statusCode = inferChecklistStatus(rowData.movementType, rowData.checklistStatus, progress);
        const statusLabel = t(CHECKLIST_STATUS_LABELS[statusCode] || statusCode || 'Pending');
        const tone =
            statusCode === 'ready_to_close' || statusCode === 'closed'
                ? 'success'
                : statusCode === 'in_progress'
                    ? 'amber'
                    : 'neutral';
        return (
            <span className={`movement-table-status movement-status-${tone}`}>
                {statusLabel} ({progress}%)
            </span>
        );
    };

    const closeCommentsBodyTemplate = (rowData) => rowData.completionComments || <span className="text-500">-</span>;

    const calculateTimeElapsed = (createdAt) => {
        if (!createdAt) return null;
        const now = new Date();
        const created = new Date(createdAt);
        const diffMs = now - created;
        return Math.floor(diffMs / (1000 * 60));
    };

    const getTimeColor = (minutes) => {
        if (minutes < 1440) return '#22c55e';
        if (minutes < 2880) return '#eab308';
        return '#ef4444';
    };

    const pendingTimeElapsedBodyTemplate = (rowData) => {
        const minutes = calculateTimeElapsed(rowData?.createdAt);
        const installationAlert = getInstallationAlert(rowData);
        const installationTiming = formatInstallationTiming(rowData, preferredLanguage);
        return (
            <div className="movement-time-stack">
                <span className="movement-open-age">
                    {minutes === null
                        ? '-'
                        : localText(
                            `Open for ${formatTimeFromMinutes(minutes, preferredLanguage)}`,
                            `Abierta hace ${formatTimeFromMinutes(minutes, preferredLanguage)}`
                        )}
                </span>
                {installationTiming && (
                    <span className={`movement-installation-timing movement-timing-${installationAlert.tone}`}>
                        {installationTiming}
                    </span>
                )}
            </div>
        );
    };

    const installationDateBodyTemplate = (rowData) => {
        const alert = getInstallationAlert(rowData);
        const label = INSTALLATION_ALERT_META[alert.code]?.label?.[preferredLanguage] || null;
        return (
            <div className="movement-installation-date">
                <span>{formatInstallationDateLabel(rowData.installationDateFrom, rowData.installationDateTo, preferredLanguage)}</span>
                {alert.code !== 'not_applicable' && label && (
                    <small className={`movement-date-state movement-date-state-${alert.tone}`}>{label}</small>
                )}
            </div>
        );
    };

    const pendingRowClassName = (rowData) => {
        const classes = [];
        if (isDemonstrationWorkflow(rowData)) classes.push('movement-demonstration-row');
        if (isSiteInspectionWorkflow(rowData)) classes.push('movement-site-inspection-row');
        const alert = getInstallationAlert(rowData);
        if (alert.code !== 'not_applicable') classes.push(`movement-installation-row-${alert.tone}`);
        return classes.join(' ');
    };

    const completedAtBodyTemplate = (rowData) => {
        if (!rowData.completedAt) return <span className="text-500">-</span>;
        return formatLocalizedDateTime(rowData.completedAt, preferredLanguage);
    };

    const openPhotoInDialog = (photoUrl) => {
        const resolvedPhoto = resolvePhotoUrl(photoUrl);
        if (!resolvedPhoto) return;
        setSelectedPhoto(resolvedPhoto);
        setSelectedPhotoError(false);
        setPhotoDialogVisible(true);
    };

    const buildAuditTimeline = (movement) => [
        ...(Array.isArray(movement?.auditLogs)
            ? movement.auditLogs.map((log, index) => ({
                  id: `${movement._id}-log-${index}`,
                  eventType: log?.eventType || 'UPDATED',
                  message: log?.message || 'Movement updated',
                  by:
                      log?.by
                          ? `${log.by.firstName || ''} ${log.by.lastName || ''}`.trim() || log.by.email || '-'
                          : '-',
                  at: log?.at || null,
                  meta: log?.meta || null
              }))
            : []),
        ...(Array.isArray(movement?.checklistAudit)
            ? movement.checklistAudit.map((entry, index) => ({
                  id: `${movement._id}-checklist-${index}`,
                  eventType: 'CHECKLIST',
                  message:
                      entry?.event === 'initialized'
                          ? 'Checklist initialized'
                          : entry?.event === 'status_changed'
                              ? `Checklist status changed to ${CHECKLIST_STATUS_LABELS[entry?.meta?.to] || entry?.meta?.to || '-'}`
                              : 'Checklist updated',
                  by:
                      entry?.by
                          ? `${entry.by.firstName || ''} ${entry.by.lastName || ''}`.trim() || entry.by.email || '-'
                          : '-',
                  at: entry?.at || null,
                  meta: entry?.meta || null
              }))
            : [])
    ].sort((a, b) => new Date(a.at || 0) - new Date(b.at || 0));

    const openViewDialog = async (rowData) => {
        setSelectedMovement(rowData);
        setViewDialogVisible(true);
        if (!rowData?._id) return;

        setSelectedMovementLoading(true);
        try {
            const response = await handleGetRequest(endPoints.getMachineMovement(rowData._id), true, false, dispatch);
            if (response?.data) {
                const movement = response.data;
                setSelectedMovement({
                    ...rowData,
                    photo: movement.photo || '',
                    requestPhotos: normalizePhotoList(movement.photo, movement.requestPhotos),
                    completionPhoto: movement.completionPhoto || '',
                    completionPhotos: normalizePhotoList(movement.completionPhoto, movement.completionPhotos),
                    installationDetails: movement.installationDetails || null,
                    auditTimeline: buildAuditTimeline(movement),
                    raw: movement
                });
            }
        } catch (error) {
            console.error('Error loading movement details:', error);
        } finally {
            setSelectedMovementLoading(false);
        }
    };

    const handleDeleteMovement = (rowData) => {
        if (!rowData?._id) return;

        confirmDialog({
            message: t('Are you sure you want to delete this pending movement? This action cannot be undone.'),
            header: t('Confirm Pending Movement Deletion'),
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Delete Movement'),
            rejectLabel: t('Cancel'),
            accept: async () => {
                const response = await dispatch(handleDeleteRequest(endPoints.deleteMachineMovement(rowData._id), true, true));
                if (response?.status === 200) {
                    setViewDialogVisible(false);
                    setSelectedMovement(null);
                    setChecklistDialogVisible(false);
                    setCloseDialogVisible(false);
                    await loadMovements();
                }
            },
            reject: () => {}
        });
    };

    const getTimelineEvents = (rowData) => {
        const logs = Array.isArray(rowData?.auditTimeline) ? [...rowData.auditTimeline] : [];
        if (logs.length > 0) return logs;

        const fallbackEvents = [
            {
                id: `${rowData?._id}-created`,
                eventType: 'CREATED',
                message: t('Movement request created'),
                by: rowData?.requestedBy || '-',
                at: rowData?.createdAt || null
            }
        ];
        if (rowData?.completedAt) {
            fallbackEvents.push({
                id: `${rowData?._id}-closed`,
                eventType: 'CLOSED',
                message: `${t('Movement closed as')} ${t(rowData?.movementType || '-')}`,
                by: rowData?.completedBy || '-',
                at: rowData?.completedAt
            });
        }
        return fallbackEvents;
    };

    const getTimelineEventStyle = (eventType) => {
        if (eventType === 'CREATED') {
            return { color: '#2563eb', background: 'rgba(37,99,235,0.1)' };
        }
        if (eventType === 'CLOSED') {
            return { color: '#16a34a', background: 'rgba(22,163,74,0.1)' };
        }
        return { color: '#7c3aed', background: 'rgba(124,58,237,0.1)' };
    };

    const getDataQualityPrompts = (rowData) => {
        if (!rowData) return [];
        const prompts = [];
        const minutesOpen = calculateTimeElapsed(rowData.createdAt);

        if (!rowData.machineId || rowData.machineId === '-') {
            prompts.push(t('Machine ID is missing.'));
        }
        if (!rowData.machineType || rowData.machineType === '-') {
            prompts.push(t('Machine Type is missing.'));
        }
        if (!rowData.requestedBy || rowData.requestedBy === '-') {
            prompts.push(t('Requester is missing (legacy record or unknown user).'));
        }
        if (OPEN_MOVEMENT_TYPES.includes(rowData.movementType) && rowData.checklistTemplateKey && isChecklistBlockingClose(rowData)) {
            prompts.push(t('Checklist is incomplete ({0}%). Complete required items before closing.').replace('{0}', String(rowData.checklistProgress || 0)));
        }
        if (normalizePhotoList(rowData.photo, rowData.requestPhotos).length === 0 && minutesOpen !== null && OPEN_MOVEMENT_TYPES.includes(rowData.movementType) && minutesOpen > 120) {
            prompts.push(t('Open movement is older than 2 hours and has no request photo.'));
        }
        if (FINAL_MOVEMENT_TYPES.includes(rowData.movementType) && normalizePhotoList(rowData.completionPhoto, rowData.completionPhotos).length === 0) {
            prompts.push(t('Closed movement has no close photo.'));
        }
        if (FINAL_MOVEMENT_TYPES.includes(rowData.movementType) && !rowData.completionComments) {
            prompts.push(t('Closed movement has no close comments.'));
        }
        return prompts;
    };

    const buildPendingExportRows = () => pendingTableRows.map((m) => {
        const minutes = calculateTimeElapsed(m.createdAt);
        return {
            'Installation Date': formatInstallationDateLabel(m.installationDateFrom, m.installationDateTo, preferredLanguage),
            'Time Elapsed': minutes === null ? '-' : formatTimeFromMinutes(minutes, preferredLanguage),
            'Movement Type': m.isDemonstration
                ? localText('Demonstration', 'Demostración')
                : OPEN_MOVEMENT_TYPES.includes(m.movementType)
                ? `${m.movementType} (${MOVEMENT_TYPE_LABELS[m.requestedMovementType] || m.requestedMovementType || 'Installation'})`
                : m.movementType,
            'Customer': m.customer,
            'Location': m.toLocation,
            'Technician': m.technician,
            'Receiving Contact': m.installationDetails?.contactName || '-',
            'Contact Phone': m.installationDetails?.contactPhone || '-',
            'Google Maps': m.installationDetails?.mapUrl || '-',
            'Priority': m.installationDetails?.priority || '-',
            'Payment Methods': Array.isArray(m.installationDetails?.paymentMethods)
                ? m.installationDetails.paymentMethods.join(', ')
                : '-'
        };
    });

    const buildCompletedExportRows = () => completedTableRows.map((m) => {
        return {
            'Machine ID': m.machineId,
            'Machine Type': m.machineType,
            'Movement Type': m.isDemonstration
                ? localText('Demonstration', 'Demostración')
                : m.movementType,
            'Installation Date': formatInstallationDateLabel(m.installationDateFrom, m.installationDateTo, preferredLanguage),
            'Date': m.date,
            'Customer': m.customer,
            'Location': m.toLocation,
            'Technician': m.technician,
            'Receiving Contact': m.installationDetails?.contactName || '-',
            'Contact Phone': m.installationDetails?.contactPhone || '-',
            'Close Comments': m.completionComments || '-',
            'Completed By': m.completedBy || '-',
            'Completed At': formatLocalizedDateTime(m.completedAt, preferredLanguage)
        };
    });

    const actionsBodyTemplate = (rowData) => {
        if (rowData.isSiteInspection) {
            return (
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-text p-button-sm"
                    tooltip={localText('View site inspection', 'Ver inspección de sitio')}
                    tooltipOptions={{ position: 'top' }}
                    aria-label={localText('View site inspection', 'Ver inspección de sitio')}
                    onClick={() => siteInspectionControllerRef.current?.openDetails(rowData)}
                />
            );
        }
        if (rowData.isDemonstration) {
            const linkedMovement = (rowData.linkedMovements || [])
                .filter((movement) => OPEN_MOVEMENT_TYPES.includes(movement.movementType))
                .sort((left, right) => (
                    left.workflowType === 'demo_pickup'
                        ? -1
                        : right.workflowType === 'demo_pickup'
                            ? 1
                            : 0
                ))[0];
            return (
                <div className="flex gap-1 align-items-center">
                    <Button
                        icon="pi pi-eye"
                        className="p-button-rounded p-button-text p-button-sm"
                        tooltip={localText('View demonstration', 'Ver demostración')}
                        tooltipOptions={{ position: 'top' }}
                        aria-label={localText('View demonstration', 'Ver demostración')}
                        onClick={() =>
                            demonstrationControllerRef.current?.openDetails(
                                rowData.rawDemo
                            )
                        }
                    />
                    {canCloseDemonstration(rowData.rawDemo, currentAdmin) ? (
                        <Button
                            label={localText('Close demonstration', 'Cerrar demostración')}
                            icon="pi pi-check-square"
                            className="p-button-success p-button-sm"
                            onClick={() => demonstrationControllerRef.current?.openClose(rowData.rawDemo)}
                        />
                    ) : null}
                    {linkedMovement ? (
                        <Button
                            icon="pi pi-wrench"
                            className="p-button-rounded p-button-text p-button-help p-button-sm"
                            tooltip={localText('Open technical movement', 'Abrir movimiento técnico')}
                            tooltipOptions={{ position: 'top' }}
                            aria-label={localText('Open technical movement', 'Abrir movimiento técnico')}
                            onClick={() => openViewDialog(linkedMovement)}
                        />
                    ) : null}
                </div>
            );
        }
        const canDeleteRow =
            canDeletePendingMovements && OPEN_MOVEMENT_TYPES.includes(rowData.movementType);
        return (
            <div className="flex gap-1 align-items-center">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-text p-button-sm"
                    tooltip={t('View')}
                    tooltipOptions={{ position: 'top' }}
                    aria-label={t('View')}
                    onClick={() => openViewDialog(rowData)}
                />
                {canDeleteRow && (
                    <Button
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-text p-button-danger p-button-sm"
                        tooltip={t('Delete Movement')}
                        tooltipOptions={{ position: 'top' }}
                        onClick={() => handleDeleteMovement(rowData)}
                    />
                )}
            </div>
        );
    };

    const openMovementDialog = () => {
        setMovementForm({
            technicianId: '',
            customer: '',
            machineId: '',
            machineType: '',
            movementType: '',
            fromLocation: '',
            toLocation: '',
            installationDateRange: null,
            installationDetails: makeDefaultInstallationDetails(),
            requestPhotos: [],
            comments: '',
            clientRequestId: buildMovementRequestId(),
            siteInspectionId: ''
        });
        setMovementDialogVisible(true);
    };

    const openInstallationFromInspection = (inspection) => {
        const defaultDetails = makeDefaultInstallationDetails();
        setMovementForm({
            technicianId: inspection.assignedTechnician?._id || currentAdmin?._id || '',
            customer: inspection.client?.name || '',
            machineId: '',
            machineType: inspection.plannedEquipment?.machineType || '',
            movementType: 'Installed',
            fromLocation: localText('Workshop', 'Taller'),
            toLocation: inspection.client?.address || inspection.client?.locationName || '',
            installationDateRange: null,
            installationDetails: {
                ...defaultDetails,
                contactName: inspection.client?.contactName || '',
                contactPhone: inspection.client?.contactPhone || '',
                mapUrl: inspection.client?.mapUrl || '',
                specificArea: inspection.client?.specificArea || '',
                accessInstructions: inspection.accessInstructions || '',
                specialRequirements: inspection.adjustmentSummary || inspection.overallNotes || ''
            },
            requestPhotos: Array.isArray(inspection.generalPhotos)
                ? inspection.generalPhotos.slice(0, MAX_REQUEST_PHOTOS)
                : [],
            comments: `${localText('Created from site inspection', 'Creado desde inspección de sitio')} ${inspection.inspectionNumber || ''}`.trim(),
            clientRequestId: `inspection:${inspection._id}:installation`,
            siteInspectionId: inspection._id
        });
        setMovementDialogVisible(true);
    };

    const updateInstallationDetail = (field, value) => {
        setMovementForm((current) => ({
            ...current,
            installationDetails: {
                ...(current.installationDetails || makeDefaultInstallationDetails()),
                [field]: value
            }
        }));
    };

    const changeMovementType = (movementType) => {
        setMovementForm((current) => {
            const selectedMachine = machines.find((machine) => machine._id === current.machineId);
            const shouldClearMachine =
                movementType === 'Installed' &&
                selectedMachine &&
                selectedMachine.inStockInventory !== true;
            return {
                ...current,
                movementType,
                machineId: shouldClearMachine ? '' : current.machineId,
                installationDetails:
                    movementType === 'Installed'
                        ? current.installationDetails || makeDefaultInstallationDetails()
                        : {
                            ...makeDefaultInstallationDetails(),
                            contactEmail: current.installationDetails?.contactEmail || ''
                        }
            };
        });
    };

    const saveMovement = async () => {
        if (movementSaving) return;
        const contactEmail = movementForm.installationDetails?.contactEmail?.trim() || '';
        if (contactEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactEmail)) {
            toast.warn(localText('Enter a valid contact email.', 'Ingrese un correo de contacto válido.'));
            return;
        }
        if (movementForm.movementType === 'Installed') {
            const details = movementForm.installationDetails || {};
            if (details.mapUrl?.trim()) {
                try {
                    const mapUrl = new URL(details.mapUrl.trim());
                    if (!['http:', 'https:'].includes(mapUrl.protocol)) throw new Error('invalid protocol');
                } catch (error) {
                    toast.warn(localText('Enter a valid Google Maps link.', 'Ingrese un enlace válido de Google Maps.'));
                    return;
                }
            }
            const hasUnconfirmedConditions =
                details.electricityStatus === 'unknown' ||
                (movementForm.machineType === 'coffee' && details.waterSupply === 'unknown') ||
                (details.telemetryRequired === 'yes' && details.connectivity === 'unknown');
            if (hasUnconfirmedConditions) {
                toast.warn(
                    localText(
                        'Some technical conditions are still unconfirmed. A prior inspection may be required.',
                        'Hay condiciones técnicas por confirmar. Puede ser necesaria una inspección previa.'
                    )
                );
            }
        }
        const requestPhotos = normalizePhotoList(null, movementForm.requestPhotos).slice(0, MAX_REQUEST_PHOTOS);
        const installationRange = Array.isArray(movementForm.installationDateRange)
            ? movementForm.installationDateRange
            : movementForm.installationDateRange
                ? [movementForm.installationDateRange]
                : [];
        const installationDateFrom = installationRange[0] || null;
        const installationDateTo = installationRange[1] || installationRange[0] || null;
        const payload = {
            technicianId: movementForm.technicianId,
            customer: movementForm.customer,
            location: movementForm.toLocation,
            machineId: movementForm.machineId,
            machineType: movementForm.machineType,
            movementType: 'Pending',
            requestedMovementType: movementForm.movementType,
            fromLocation: movementForm.fromLocation,
            toLocation: movementForm.toLocation,
            installationDateFrom,
            installationDateTo,
            installationDetails:
                movementForm.movementType === 'Installed'
                    ? { ...movementForm.installationDetails, contactEmail }
                    : contactEmail ? { contactEmail } : undefined,
            photo: requestPhotos[0] || null,
            requestPhotos,
            comments: movementForm.comments,
            clientRequestId: movementForm.clientRequestId || buildMovementRequestId()
        };
        setMovementSaving(true);
        try {
            const response = await dispatch(handlePostRequest(payload, endPoints.addMachineMovement, true));
            if (response?.status === 201 || response?.status === 200) {
                const createdMovementId = response?.data?.data?._id;
                if (movementForm.siteInspectionId && createdMovementId) {
                    await updateSiteInspection(
                        movementForm.siteInspectionId,
                        { linkedMovementId: createdMovementId },
                        dispatch
                    );
                    await loadSiteInspectionWorkflows();
                }
                setMovementDialogVisible(false);
                await loadMovements();
            }
        } finally {
            setMovementSaving(false);
        }
    };

    const renderMovementDialogFooter = () => {
        const installationDetails = movementForm.installationDetails || {};
        const missingInstallationDetails =
            movementForm.movementType === 'Installed' &&
            (!movementForm.installationDateRange ||
                !installationDetails.contactName?.trim() ||
                !installationDetails.contactPhone?.trim() ||
                !installationDetails.paymentMethods?.length);
        const isDisabled =
            !movementForm.technicianId ||
            !movementForm.customer ||
            !movementForm.fromLocation ||
            !movementForm.toLocation ||
            !movementForm.movementType ||
            !movementForm.machineType ||
            missingInstallationDetails;

        return (
            <div className="flex justify-content-end gap-2">
                <Button label={t('Cancel')} icon="pi pi-times" className="p-button-text" onClick={() => setMovementDialogVisible(false)} disabled={movementSaving} />
                <Button label={t('Save')} icon="pi pi-check" className="p-button-primary" onClick={saveMovement} disabled={isDisabled || movementSaving} loading={movementSaving} />
            </div>
        );
    };

    const renderCloseDialogFooter = () => {
        const movementToClose = allMovements.find((item) => item._id === closeForm.movementId);
        const closeBlocked = isChecklistBlockingClose(movementToClose);
        const requiresInstallationConfirmation = isInstallationCloseType(
            closeForm.finalMovementType || movementToClose?.requestedMovementType
        );
        const installationNotConfirmed =
            requiresInstallationConfirmation && !closeForm.installationConfirmed;
        return (
            <div className="flex justify-content-end gap-2">
                <Button label={t('Cancel')} icon="pi pi-times" className="p-button-text" onClick={() => setCloseDialogVisible(false)} />
                <Button
                    label={t('Close Movement')}
                    icon="pi pi-check"
                    className="p-button-success"
                    onClick={submitCloseMovement}
                    disabled={closeBlocked || installationNotConfirmed}
                    title={
                        closeBlocked
                            ? t('Complete checklist first')
                            : installationNotConfirmed
                                ? localText(
                                    'Confirm the physical installation first',
                                    'Confirme primero la instalación física'
                                )
                                : t('Close Movement')
                    }
                />
            </div>
        );
    };

    const exportPendingMovements = (format = 'xlsx') => {
        const exportData = buildPendingExportRows();
        const dateFilter = pendingDateRange.from || pendingDateRange.to 
            ? `_${pendingDateRange.from ? new Date(pendingDateRange.from).toISOString().split('T')[0] : 'all'}_to_${pendingDateRange.to ? new Date(pendingDateRange.to).toISOString().split('T')[0] : 'all'}`
            : '';
        if (format === 'csv') {
            exportToCsv(exportData, `Pending_Movements${dateFilter}`, null);
            return;
        }
        exportToExcel(exportData, `Pending_Movements${dateFilter}`, null);
    };

    const exportCompletedMovements = (format = 'xlsx') => {
        const exportData = buildCompletedExportRows();
        const dateFilter = installedDateRange.from || installedDateRange.to 
            ? `_${installedDateRange.from ? new Date(installedDateRange.from).toISOString().split('T')[0] : 'all'}_to_${installedDateRange.to ? new Date(installedDateRange.to).toISOString().split('T')[0] : 'all'}`
            : '';
        if (format === 'csv') {
            exportToCsv(exportData, `Completed_Movements${dateFilter}`, null);
            return;
        }
        exportToExcel(exportData, `Completed_Movements${dateFilter}`, null);
    };

    const checklistReadOnly = checklistForm?.movementType && FINAL_MOVEMENT_TYPES.includes(checklistForm.movementType);
    const completedTotalRecords = completedTableRows.length;
    const onCompletedPage = (event) => {
        setCompletedPagination((current) => ({
            ...current,
            first: event.first,
            rows: event.rows,
            page: Math.floor(event.first / event.rows) + 1
        }));
    };
    const resetCompletedPage = () => {
        setCompletedPagination((current) => ({ ...current, first: 0, page: 1 }));
    };
    const updateInstalledDateRange = (patch) => {
        setInstalledDateRange((current) => ({ ...current, ...patch }));
        setCompletedPagination((current) => ({
            ...current,
            first: 0,
            page: 1
        }));
    };

    const createMenuItems = [
        !demonstrationsOnly && {
            label: localText('Movement', 'Movimiento'),
            icon: 'pi pi-truck',
            command: openMovementDialog
        },
        canCreateDemonstration && {
            label: localText('Demonstration', 'Demostración'),
            icon: 'pi pi-star',
            command: () => demonstrationControllerRef.current?.openCreate()
        },
        canCreateSiteInspection && {
            label: localText('Site inspection', 'Inspección de sitio'),
            icon: 'pi pi-map-marker',
            command: () => siteInspectionControllerRef.current?.openCreate()
        }
    ].filter(Boolean);

    return (
        <div>
            <ConfirmDialog />
            <Dialog
                header={t('New Machine Movement')}
                visible={movementDialogVisible}
                style={{ width: 'min(94vw, 72rem)' }}
                modal
                className="movement-request-dialog"
                onHide={() => setMovementDialogVisible(false)}
                footer={renderMovementDialogFooter()}
            >
                <div className="grid p-fluid">
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">
                            {t('Assigned Technician')} <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            value={movementForm.technicianId}
                            options={technicians}
                            optionLabel="label"
                            optionValue="_id"
                            onChange={(e) => setMovementForm({ ...movementForm, technicianId: e.value })}
                            placeholder={t('Select technician')}
                            className="w-full"
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">
                            {t('Customer')} <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={movementForm.customer} onChange={(e) => setMovementForm({ ...movementForm, customer: e.target.value })} placeholder={t('Customer name')} className="w-full" />
                    </div>
                    <div className="col-12 md:col-6">
                        <label htmlFor="movement-contact-email" className="block mb-2">
                            {localText('Customer or contact email (optional)', 'Correo del cliente o contacto (opcional)')}
                        </label>
                        <InputText
                            id="movement-contact-email"
                            type="email"
                            autoComplete="email"
                            maxLength={200}
                            value={movementForm.installationDetails.contactEmail}
                            onChange={(e) => updateInstallationDetail('contactEmail', e.target.value)}
                            placeholder="contacto@empresa.com"
                            className="w-full"
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">
                            {t('Movement Type')} <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown value={movementForm.movementType} options={movementTypeOptions} onChange={(e) => changeMovementType(e.value)} placeholder={t('Select movement type')} className="w-full" />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">
                            {t('From Location')} <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={movementForm.fromLocation} onChange={(e) => setMovementForm({ ...movementForm, fromLocation: e.target.value })} placeholder={t('e.g., Warehouse')} className="w-full" />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">
                            {t('To Location')} <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={movementForm.toLocation} onChange={(e) => setMovementForm({ ...movementForm, toLocation: e.target.value })} placeholder={t('Destination location')} className="w-full" />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">
                            {t('Installation Date')} {isNormalInstallation && <span className="required-mark">*</span>}
                        </label>
                        <Calendar
                            value={movementForm.installationDateRange}
                            onChange={(e) => setMovementForm({ ...movementForm, installationDateRange: e.value })}
                            selectionMode="range"
                            readOnlyInput
                            showIcon
                            showTime={isNormalInstallation}
                            hourFormat="12"
                            placeholder={
                                isNormalInstallation
                                    ? localText('Select installation date and time', 'Seleccione fecha y hora de instalación')
                                    : t('Select one day or a date range')
                            }
                            className="w-full"
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">{t('Machine (Optional)')}</label>
                        <Dropdown
                            value={movementForm.machineId}
                            options={movementMachineOptions}
                            optionLabel="label"
                            optionValue="_id"
                            onChange={(e) => {
                                const selectedMachine = machines.find((m) => m._id === e.value);
                                setMovementForm({
                                    ...movementForm,
                                    machineId: e.value,
                                    machineType: selectedMachine?.type || movementForm.machineType,
                                    fromLocation:
                                        selectedMachine?.inStockInventory && !movementForm.fromLocation
                                            ? selectedMachine.location || 'Warehouse'
                                            : movementForm.fromLocation
                                });
                            }}
                            placeholder={t('Select machine (ID - Type - Location)')}
                            className="w-full"
                            filter
                            filterBy="label"
                            emptyMessage={
                                isNormalInstallation
                                    ? localText('No in-stock machines are available', 'No hay máquinas disponibles en inventario')
                                    : localText('No machines are available', 'No hay máquinas disponibles')
                            }
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">
                            {t('Type')} <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            value={movementForm.machineType}
                            options={machineTypeOptions}
                            onChange={(e) => setMovementForm({ ...movementForm, machineType: e.value })}
                            placeholder={t('Select machine type')}
                            className="w-full"
                        />
                    </div>
                    {isNormalInstallation && (
                        <div className="col-12">
                            <div className="installation-details-panel">
                                <div className="installation-details-heading">
                                    <span className="installation-details-icon"><i className="pi pi-building" /></span>
                                    <div>
                                        <h4>{localText('Installation details', 'Detalles de la instalación')}</h4>
                                        <p>
                                            {localText(
                                                'Information the technical and logistics teams need before visiting the customer.',
                                                'Información que Técnicos y Logística necesitan antes de visitar al cliente.'
                                            )}
                                        </p>
                                    </div>
                                </div>

                                <div className="installation-form-section">
                                    <h5><i className="pi pi-user" /> {localText('Contact and access', 'Contacto y acceso')}</h5>
                                    <div className="grid p-fluid">
                                        <div className="col-12 md:col-4">
                                            <label className="block mb-2">
                                                {localText('Receiving contact', 'Persona que recibirá')} <span className="required-mark">*</span>
                                            </label>
                                            <InputText
                                                value={movementForm.installationDetails.contactName}
                                                onChange={(e) => updateInstallationDetail('contactName', e.target.value)}
                                                placeholder={localText('Full name', 'Nombre completo')}
                                            />
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label className="block mb-2">
                                                {localText('Contact phone', 'Teléfono de contacto')} <span className="required-mark">*</span>
                                            </label>
                                            <InputText
                                                value={movementForm.installationDetails.contactPhone}
                                                onChange={(e) => updateInstallationDetail('contactPhone', e.target.value)}
                                                placeholder="6000-0000"
                                            />
                                        </div>
                                        <div className="col-12 md:col-8">
                                            <label className="block mb-2">{localText('Google Maps link', 'Enlace de Google Maps')}</label>
                                            <InputText
                                                value={movementForm.installationDetails.mapUrl}
                                                onChange={(e) => updateInstallationDetail('mapUrl', e.target.value)}
                                                placeholder="https://maps.google.com/..."
                                            />
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label className="block mb-2">{localText('Floor, suite or area', 'Piso, local o área')}</label>
                                            <InputText
                                                value={movementForm.installationDetails.specificArea}
                                                onChange={(e) => updateInstallationDetail('specificArea', e.target.value)}
                                                placeholder={localText('Exact installation area', 'Área exacta de instalación')}
                                            />
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label className="block mb-2">{localText('Allowed access hours', 'Horario permitido de ingreso')}</label>
                                            <InputText
                                                value={movementForm.installationDetails.accessHours}
                                                onChange={(e) => updateInstallationDetail('accessHours', e.target.value)}
                                                placeholder={localText('e.g. 8:00 a.m. to 11:00 a.m.', 'Ej. 8:00 a.m. a 11:00 a.m.')}
                                            />
                                        </div>
                                        <div className="col-12 md:col-8">
                                            <label className="block mb-2">{localText('Access conditions', 'Condiciones de acceso')}</label>
                                            <MultiSelect
                                                value={movementForm.installationDetails.accessFeatures}
                                                options={accessFeatureOptions}
                                                onChange={(e) => updateInstallationDetail('accessFeatures', e.value)}
                                                display="chip"
                                                placeholder={localText('Select all that apply', 'Seleccione las que correspondan')}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="block mb-2">{localText('Access instructions', 'Instrucciones de ingreso')}</label>
                                            <InputTextarea
                                                rows={2}
                                                value={movementForm.installationDetails.accessInstructions}
                                                onChange={(e) => updateInstallationDetail('accessInstructions', e.target.value)}
                                                placeholder={localText('Security registration, loading access, contact on arrival...', 'Registro de seguridad, acceso de carga, contacto al llegar...')}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="installation-form-section">
                                    <h5><i className="pi pi-calendar" /> {localText('Scheduling and technical conditions', 'Programación y condiciones técnicas')}</h5>
                                    <div className="grid p-fluid">
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Priority', 'Prioridad')}</label>
                                            <Dropdown
                                                value={movementForm.installationDetails.priority}
                                                options={priorityOptions}
                                                onChange={(e) => updateInstallationDetail('priority', e.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Estimated duration', 'Duración estimada')}</label>
                                            <InputNumber
                                                value={movementForm.installationDetails.estimatedDurationMinutes}
                                                onValueChange={(e) => updateInstallationDetail('estimatedDurationMinutes', e.value)}
                                                suffix={localText(' min', ' min')}
                                                min={0}
                                                max={10080}
                                            />
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Electricity', 'Electricidad')}</label>
                                            <Dropdown
                                                value={movementForm.installationDetails.electricityStatus}
                                                options={electricityOptions}
                                                onChange={(e) => updateInstallationDetail('electricityStatus', e.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Voltage', 'Voltaje')}</label>
                                            <Dropdown
                                                value={movementForm.installationDetails.voltage}
                                                options={voltageOptions}
                                                onChange={(e) => updateInstallationDetail('voltage', e.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Dedicated outlet', 'Toma dedicada')}</label>
                                            <Dropdown
                                                value={movementForm.installationDetails.dedicatedOutletStatus}
                                                options={confirmationOptions}
                                                onChange={(e) => updateInstallationDetail('dedicatedOutletStatus', e.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Water supply', 'Suministro de agua')}</label>
                                            <Dropdown
                                                value={movementForm.installationDetails.waterSupply}
                                                options={waterOptions}
                                                onChange={(e) => updateInstallationDetail('waterSupply', e.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Drainage', 'Desagüe')}</label>
                                            <Dropdown
                                                value={movementForm.installationDetails.drainageStatus}
                                                options={confirmationOptions}
                                                onChange={(e) => updateInstallationDetail('drainageStatus', e.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Connectivity', 'Conectividad')}</label>
                                            <Dropdown
                                                value={movementForm.installationDetails.connectivity}
                                                options={connectivityOptions}
                                                onChange={(e) => updateInstallationDetail('connectivity', e.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label className="block mb-2">{localText('Telemetry required', 'Requiere telemetría')}</label>
                                            <Dropdown
                                                value={movementForm.installationDetails.telemetryRequired}
                                                options={yesNoUnknownOptions}
                                                onChange={(e) => updateInstallationDetail('telemetryRequired', e.value)}
                                            />
                                        </div>
                                        <div className="col-12 md:col-9">
                                            <label className="block mb-2">
                                                {localText('Payment methods', 'Sistemas de pago')} <span className="required-mark">*</span>
                                            </label>
                                            <MultiSelect
                                                value={movementForm.installationDetails.paymentMethods}
                                                options={paymentMethodOptions}
                                                onChange={(e) => updateInstallationDetail('paymentMethods', e.value)}
                                                display="chip"
                                                placeholder={localText('Select payment methods', 'Seleccione los sistemas de pago')}
                                            />
                                        </div>
                                    </div>
                                    {(
                                        movementForm.installationDetails.electricityStatus === 'unknown' ||
                                        (movementForm.machineType === 'coffee' && movementForm.installationDetails.waterSupply === 'unknown') ||
                                        (movementForm.installationDetails.telemetryRequired === 'yes' && movementForm.installationDetails.connectivity === 'unknown')
                                    ) && (
                                        <div className="installation-warning">
                                            <i className="pi pi-exclamation-triangle" />
                                            <span>{localText('Unconfirmed conditions may require a prior inspection.', 'Las condiciones no confirmadas pueden requerir una inspección previa.')}</span>
                                        </div>
                                    )}
                                </div>

                                <div className="installation-form-section">
                                    <h5><i className="pi pi-cog" /> {localText('Equipment and logistics', 'Equipo y logística')}</h5>
                                    <div className="installation-checkbox-grid">
                                        {[
                                            ['requiresBase', localText('Base or stand', 'Base o soporte')],
                                            ['requiresFridge', localText('Cooling fridge', 'Nevera enfriadora')],
                                            ['requiresFilter', localText('Water filter', 'Filtro de agua')],
                                            ['requiresPump', localText('Water pump', 'Bomba de agua')],
                                            ['requiresHelper', localText('Loading helper', 'Ayudante de carga')]
                                        ].map(([field, label]) => (
                                            <label className="installation-checkbox" key={field}>
                                                <Checkbox
                                                    inputId={`installation-${field}`}
                                                    checked={Boolean(movementForm.installationDetails[field])}
                                                    onChange={(e) => updateInstallationDetail(field, e.checked)}
                                                />
                                                <span>{label}</span>
                                            </label>
                                        ))}
                                    </div>
                                    <div className="grid p-fluid mt-2">
                                        <div className="col-12">
                                            <label className="block mb-2">{localText('Accessories and materials', 'Accesorios y materiales')}</label>
                                            <MultiSelect
                                                value={movementForm.installationDetails.accessories}
                                                options={installationAccessoryOptions}
                                                onChange={(e) => updateInstallationDetail('accessories', e.value)}
                                                display="chip"
                                                placeholder={localText('Select required accessories', 'Seleccione los accesorios requeridos')}
                                            />
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label className="block mb-2">{localText('Initial stock', 'Stock inicial')}</label>
                                            <InputTextarea
                                                rows={3}
                                                value={movementForm.installationDetails.initialStockNotes}
                                                onChange={(e) => updateInstallationDetail('initialStockNotes', e.target.value)}
                                                placeholder={localText('Products, quantities and consumables', 'Productos, cantidades y consumibles')}
                                            />
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label className="block mb-2">{localText('Special requirements', 'Requerimientos especiales')}</label>
                                            <InputTextarea
                                                rows={3}
                                                value={movementForm.installationDetails.specialRequirements}
                                                onChange={(e) => updateInstallationDetail('specialRequirements', e.target.value)}
                                                placeholder={localText('Configuration, restrictions or customer commitments', 'Configuración, restricciones o compromisos con el cliente')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="col-12">
                        <label className="block mb-2">{t('Movement Photos')}</label>
                        <PhotoUploader
                            value=""
                            onChange={addRequestPhoto}
                            maxUploadBytes={300 * 1024}
                            maxDimension={1280}
                            helperText={t('Optional. Up to {0} photos, max 300 KB each.').replace('{0}', String(MAX_REQUEST_PHOTOS))}
                        />
                        {movementForm.requestPhotos.length > 0 && (
                            <div className="mt-3">
                                <small className="text-500 block mb-2">
                                    {movementForm.requestPhotos.length} {t(movementForm.requestPhotos.length === 1 ? 'photo added' : 'photos added')}
                                </small>
                                <div className="grid">
                                    {movementForm.requestPhotos.map((photo, index) => (
                                        <div className="col-6 md:col-4" key={`request-movement-photo-${index}`}>
                                            <div style={{ border: '1px solid rgba(148,163,184,0.4)', borderRadius: '6px', padding: '0.5rem' }}>
                                                <img
                                                    src={resolvePhotoUrl(photo) || photo}
                                                    alt={`Request ${index + 1}`}
                                                    style={{ width: '100%', maxHeight: '100px', objectFit: 'cover', borderRadius: '4px', cursor: 'zoom-in' }}
                                                    title={t('Click to enlarge')}
                                                    onClick={() => openPhotoInDialog(photo)}
                                                />
                                                <div className="flex justify-content-between mt-2">
                                                    <Button
                                                        type="button"
                                                        label={t('View')}
                                                        icon="pi pi-search-plus"
                                                        className="p-button-text p-button-sm"
                                                        onClick={() => openPhotoInDialog(photo)}
                                                    />
                                                    <Button
                                                        type="button"
                                                        label={t('Remove')}
                                                        icon="pi pi-times"
                                                        className="p-button-danger p-button-text p-button-sm"
                                                        onClick={() =>
                                                            setMovementForm((prev) => ({
                                                                ...prev,
                                                                requestPhotos: prev.requestPhotos.filter((_, i) => i !== index)
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-12">
                        <label className="block mb-2">{t('Comments')}</label>
                        <InputText value={movementForm.comments} onChange={(e) => setMovementForm({ ...movementForm, comments: e.target.value })} placeholder={t('Additional notes')} className="w-full" />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header={t('Close Pending Movement')}
                visible={closeDialogVisible}
                style={{ width: '40rem' }}
                modal
                onHide={() => setCloseDialogVisible(false)}
                footer={renderCloseDialogFooter()}
            >
                <div className="grid p-fluid">
                    {(() => {
                        const movementToClose = allMovements.find((item) => item._id === closeForm.movementId);
                        if (!movementToClose?.checklistTemplateKey) return null;
                        const closeBlocked = isChecklistBlockingClose(movementToClose);
                        return (
                            <div className="col-12">
                                <div
                                    style={{
                                        background: closeBlocked ? '#fffbeb' : '#f0fdf4',
                                        border: closeBlocked ? '1px solid #fde68a' : '1px solid #86efac',
                                        borderRadius: '8px',
                                        padding: '0.75rem'
                                    }}
                                >
                                    <div className="flex justify-content-between align-items-center flex-wrap gap-2">
                                        <span className="text-700">
                                            {t('Checklist')}: {getChecklistDisplay(movementToClose)}
                                        </span>
                                        <Button
                                            label={t('Open Checklist')}
                                            icon="pi pi-list-check"
                                            className="p-button-text p-button-sm"
                                            onClick={() => openChecklistDialog(movementToClose)}
                                        />
                                    </div>
                                    {closeBlocked && (
                                        <small className="text-700">
                                            {t('Complete required checklist items before closing this movement.')}
                                        </small>
                                    )}
                                </div>
                            </div>
                        );
                    })()}
                    {isInstallationCloseType(closeForm.finalMovementType) && (
                        <div className="col-12">
                            <div className="movement-installation-confirmation">
                                <Checkbox
                                    inputId="movement-installation-confirmed"
                                    checked={Boolean(closeForm.installationConfirmed)}
                                    onChange={(event) =>
                                        setCloseForm((current) => ({
                                            ...current,
                                            installationConfirmed: Boolean(event.checked)
                                        }))
                                    }
                                />
                                <label htmlFor="movement-installation-confirmed">
                                    {localText(
                                        'I confirm that the machine was physically installed.',
                                        'Confirmo que la máquina fue instalada físicamente.'
                                    )}
                                </label>
                            </div>
                        </div>
                    )}
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">{t('Final Status')}</label>
                        <Dropdown
                            value={closeForm.finalMovementType}
                            options={movementTypeOptions}
                            onChange={(e) => setCloseForm({ ...closeForm, finalMovementType: e.value })}
                            placeholder={t('Select final status')}
                            className="w-full"
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">{t('Machine ID')}</label>
                        <Dropdown
                            value={closeForm.machineId}
                            options={machines}
                            optionLabel="label"
                            optionValue="_id"
                            onChange={(e) => {
                                const selectedMachine = machines.find((m) => m._id === e.value);
                                setCloseForm({
                                    ...closeForm,
                                    machineId: e.value,
                                    machineType: selectedMachine?.type || closeForm.machineType
                                });
                            }}
                            placeholder={t('Select machine (optional)')}
                            className="w-full"
                            filter
                            filterBy="label"
                            showClear
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <label className="block mb-2">{t('Machine Type')}</label>
                        <Dropdown
                            value={closeForm.machineType}
                            options={machineTypeOptions}
                            onChange={(e) => setCloseForm({ ...closeForm, machineType: e.value })}
                            placeholder={t('Select machine type')}
                            className="w-full"
                            showClear
                        />
                    </div>
                    <div className="col-12">
                        <label className="block mb-2">{t('Close Comments')}</label>
                        <InputTextarea
                            value={closeForm.completionComments}
                            onChange={(e) => setCloseForm({ ...closeForm, completionComments: e.target.value })}
                            rows={3}
                            autoResize
                            placeholder={t('Add technician notes about the close action')}
                            className="w-full"
                        />
                    </div>
                    <div className="col-12">
                        <label className="block mb-2">{t('Close Photos')}</label>
                        <PhotoUploader
                            value=""
                            onChange={addClosePhoto}
                            maxUploadBytes={300 * 1024}
                            maxDimension={1280}
                            helperText={t('Optional. Up to {0} photos, max 300 KB each.').replace('{0}', String(MAX_CLOSE_PHOTOS))}
                        />
                        {closeForm.completionPhotos.length > 0 && (
                            <div className="mt-3">
                                <small className="text-500 block mb-2">
                                    {closeForm.completionPhotos.length} {t(closeForm.completionPhotos.length === 1 ? 'photo added' : 'photos added')}
                                </small>
                                <div className="grid">
                                    {closeForm.completionPhotos.map((photo, index) => (
                                        <div className="col-6 md:col-4" key={`close-movement-photo-${index}`}>
                                            <div style={{ border: '1px solid rgba(148,163,184,0.4)', borderRadius: '6px', padding: '0.5rem' }}>
                                                <img
                                                    src={resolvePhotoUrl(photo) || photo}
                                                    alt={`Close ${index + 1}`}
                                                    style={{ width: '100%', maxHeight: '100px', objectFit: 'cover', borderRadius: '4px', cursor: 'zoom-in' }}
                                                    title={t('Click to enlarge')}
                                                    onClick={() => openPhotoInDialog(photo)}
                                                />
                                                <div className="flex justify-content-between mt-2">
                                                    <Button
                                                        type="button"
                                                        label={t('View')}
                                                        icon="pi pi-search-plus"
                                                        className="p-button-text p-button-sm"
                                                        onClick={() => openPhotoInDialog(photo)}
                                                    />
                                                    <Button
                                                        type="button"
                                                        label={t('Remove')}
                                                        icon="pi pi-times"
                                                        className="p-button-danger p-button-text p-button-sm"
                                                        onClick={() =>
                                                            setCloseForm((prev) => ({
                                                                ...prev,
                                                                completionPhotos: prev.completionPhotos.filter((_, i) => i !== index)
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>

            {warehouseMachineId && <MachineWarehouseDialog machineId={warehouseMachineId} onClose={() => setWarehouseMachineId(null)} onSaved={() => { setWarehouseMachineId(null); loadMachines(); loadPendingMovements(); loadCompletedMovements(); }} />}
            <Dialog
                header={t('Movement Details')}
                visible={viewDialogVisible}
                style={{ width: '48rem' }}
                modal
                onHide={() => setViewDialogVisible(false)}
                footer={(() => {
                    const demonstration = findMovementDemonstration(selectedMovement, [...pendingDemonstrations, ...completedDemonstrations]);
                    const finalMovementType = selectedMovement?.requestedMovementType || 'Installed';
                    const closeLabel = `${t('Close as')} ${t(MOVEMENT_TYPE_LABELS[finalMovementType] || finalMovementType)}`;
                    const closeBlocked = selectedMovement ? isChecklistBlockingClose(selectedMovement) : false;
                    const canDeleteSelectedMovement =
                        canDeletePendingMovements &&
                        selectedMovement &&
                        OPEN_MOVEMENT_TYPES.includes(selectedMovement.movementType);
                    return (
                        <div className="flex justify-content-end gap-2">
                            {selectedMovement?.machineRefId && canManageWarehouse(currentAdmin) && <Button label="Registro de bodega" icon="pi pi-box" onClick={() => setWarehouseMachineId(selectedMovement.machineRefId)} />}
                            {canDeleteSelectedMovement && (
                                <Button
                                    label={t('Delete Movement')}
                                    icon="pi pi-trash"
                                    className="p-button-danger p-button-sm"
                                    onClick={() => handleDeleteMovement(selectedMovement)}
                                />
                            )}
                            {(selectedMovement?.checklistTemplateKey || OPEN_MOVEMENT_TYPES.includes(selectedMovement?.movementType)) && (
                                <Button
                                    label={t('Checklist')}
                                    icon="pi pi-list-check"
                                    className="p-button-warning p-button-sm"
                                    onClick={() => openChecklistDialog(selectedMovement)}
                                />
                            )}
                            {canCloseDemonstration(demonstration, currentAdmin) && (
                                <Button
                                    label={localText('Close demonstration', 'Cerrar demostración')}
                                    icon="pi pi-check-square"
                                    className="p-button-success p-button-sm"
                                    onClick={() => {
                                        setViewDialogVisible(false);
                                        demonstrationControllerRef.current?.openClose(demonstration);
                                    }}
                                />
                            )}
                            {selectedMovement && OPEN_MOVEMENT_TYPES.includes(selectedMovement.movementType) && (
                                <Button
                                    label={closeLabel}
                                    icon="pi pi-check"
                                    className="p-button-success p-button-sm"
                                    onClick={() => openCloseDialog(selectedMovement)}
                                    disabled={closeBlocked}
                                    title={closeBlocked ? t('Complete checklist first') : closeLabel}
                                />
                            )}
                            <Button label={t('Close')} icon="pi pi-times" className="p-button-text" onClick={() => setViewDialogVisible(false)} />
                        </div>
                    );
                })()}
            >
                {selectedMovementLoading ? (
                    <div className="text-500">{t('Loading movement details...')}</div>
                ) : selectedMovement ? (
                    <div className="grid p-fluid">
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Movement ID')}</label>
                            <div>{selectedMovement._id || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Requested By')}</label>
                            <div>{selectedMovement.requestedBy || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Technician')}</label>
                            <div>{selectedMovement.technician || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Customer')}</label>
                            <div>{selectedMovement.customer || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Machine ID')}</label>
                            <div>{selectedMovement.machineId || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Machine Type')}</label>
                            <div>{selectedMovement.machineType || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Current Status')}</label>
                            <div>{t(selectedMovement.movementType || '-')}</div>
                            {(() => {
                                const physical = machines.find(m => m._id === selectedMovement.machineRefId);
                                return physical ? <small>{physical.inStockInventory ? 'En bodega' : 'Fuera de inventario'}{physical.inStockInventory && OPEN_MOVEMENT_TYPES.includes(selectedMovement.movementType) && ['Installed', 'Exchanged - Installed'].includes(selectedMovement.requestedMovementType) ? ' · Reservada para instalación' : ''}</small> : null;
                            })()}
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Requested Final Type')}</label>
                            <div>{t(MOVEMENT_TYPE_LABELS[selectedMovement.requestedMovementType] || selectedMovement.requestedMovementType || '-')}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Checklist Template')}</label>
                            <div>{selectedMovement.checklistTemplateKey || t('N/A')}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Checklist Status')}</label>
                            <div>{getChecklistDisplay(selectedMovement)}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('From Location')}</label>
                            <div>{selectedMovement.fromLocation || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('To Location')}</label>
                            <div>{selectedMovement.toLocation || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Installation Date')}</label>
                            <div>{formatInstallationDateLabel(selectedMovement.installationDateFrom, selectedMovement.installationDateTo, preferredLanguage)}</div>
                        </div>
                        {selectedMovement.requestedMovementType !== 'Installed' && (
                            <div className="col-12 md:col-6">
                                <label className="block text-500 mb-1">{localText('Customer or contact email', 'Correo del cliente o contacto')}</label>
                                <div>{selectedMovement.installationDetails?.contactEmail || '-'}</div>
                            </div>
                        )}
                        {selectedMovement.requestedMovementType === 'Installed' && selectedMovement.installationDetails && (
                            <div className="col-12">
                                <div className="movement-detail-installation">
                                    <h4><i className="pi pi-building" /> {localText('Installation details', 'Detalles de la instalación')}</h4>
                                    <div className="grid">
                                        <div className="col-12 md:col-4">
                                            <label>{localText('Receiving contact', 'Persona que recibirá')}</label>
                                            <span>{selectedMovement.installationDetails.contactName || '-'}</span>
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label>{localText('Phone', 'Teléfono')}</label>
                                            <span>{selectedMovement.installationDetails.contactPhone || '-'}</span>
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label>{localText('Email', 'Correo')}</label>
                                            <span>{selectedMovement.installationDetails.contactEmail || '-'}</span>
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label>{localText('Specific area', 'Área específica')}</label>
                                            <span>{selectedMovement.installationDetails.specificArea || '-'}</span>
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label>{localText('Access hours', 'Horario de ingreso')}</label>
                                            <span>{selectedMovement.installationDetails.accessHours || '-'}</span>
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label>Google Maps</label>
                                            {resolveSafeWebUrl(selectedMovement.installationDetails.mapUrl) ? (
                                                <a href={resolveSafeWebUrl(selectedMovement.installationDetails.mapUrl)} target="_blank" rel="noreferrer">
                                                    {localText('Open location', 'Abrir ubicación')} <i className="pi pi-external-link" />
                                                </a>
                                            ) : <span>-</span>}
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label>{localText('Priority', 'Prioridad')}</label>
                                            <span>{getLocalizedOptionLabel(PRIORITY_OPTIONS, selectedMovement.installationDetails.priority)}</span>
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label>{localText('Electricity', 'Electricidad')}</label>
                                            <span>{getLocalizedOptionLabel(ELECTRICITY_OPTIONS, selectedMovement.installationDetails.electricityStatus)}</span>
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label>{localText('Voltage', 'Voltaje')}</label>
                                            <span>{getLocalizedOptionLabel(VOLTAGE_OPTIONS, selectedMovement.installationDetails.voltage)}</span>
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label>{localText('Water supply', 'Suministro de agua')}</label>
                                            <span>{getLocalizedOptionLabel(WATER_OPTIONS, selectedMovement.installationDetails.waterSupply)}</span>
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label>{localText('Dedicated outlet', 'Toma dedicada')}</label>
                                            <span>{getLocalizedOptionLabel(CONFIRMATION_OPTIONS, selectedMovement.installationDetails.dedicatedOutletStatus)}</span>
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label>{localText('Drainage', 'Desagüe')}</label>
                                            <span>{getLocalizedOptionLabel(CONFIRMATION_OPTIONS, selectedMovement.installationDetails.drainageStatus)}</span>
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label>{localText('Connectivity', 'Conectividad')}</label>
                                            <span>{getLocalizedOptionLabel(CONNECTIVITY_OPTIONS, selectedMovement.installationDetails.connectivity)}</span>
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label>{localText('Telemetry', 'Telemetría')}</label>
                                            <span>{getLocalizedOptionLabel(YES_NO_UNKNOWN_OPTIONS, selectedMovement.installationDetails.telemetryRequired)}</span>
                                        </div>
                                        <div className="col-12 md:col-3">
                                            <label>{localText('Estimated duration', 'Duración estimada')}</label>
                                            <span>
                                                {selectedMovement.installationDetails.estimatedDurationMinutes
                                                    ? `${selectedMovement.installationDetails.estimatedDurationMinutes} min`
                                                    : '-'}
                                            </span>
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label>{localText('Payment methods', 'Sistemas de pago')}</label>
                                            <span>{getLocalizedOptionList(PAYMENT_METHOD_OPTIONS, selectedMovement.installationDetails.paymentMethods)}</span>
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <label>{localText('Accessories', 'Accesorios')}</label>
                                            <span>{getLocalizedOptionList(INSTALLATION_ACCESSORY_OPTIONS, selectedMovement.installationDetails.accessories)}</span>
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label>{localText('Access conditions', 'Condiciones de acceso')}</label>
                                            <span>{getLocalizedOptionList(ACCESS_FEATURE_OPTIONS, selectedMovement.installationDetails.accessFeatures)}</span>
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label>{localText('Equipment and logistics requirements', 'Requerimientos de equipo y logística')}</label>
                                            <span>{getInstallationRequirementList(selectedMovement.installationDetails)}</span>
                                        </div>
                                        <div className="col-12">
                                            <label>{localText('Access instructions', 'Instrucciones de ingreso')}</label>
                                            <span>{selectedMovement.installationDetails.accessInstructions || '-'}</span>
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label>{localText('Initial stock', 'Stock inicial')}</label>
                                            <span>{selectedMovement.installationDetails.initialStockNotes || '-'}</span>
                                        </div>
                                        <div className="col-12 md:col-6">
                                            <label>{localText('Special requirements', 'Requerimientos especiales')}</label>
                                            <span>{selectedMovement.installationDetails.specialRequirements || '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Requested At')}</label>
                            <div>{formatLocalizedDateTime(selectedMovement.createdAt, preferredLanguage)}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Completed At')}</label>
                            <div>{formatLocalizedDateTime(selectedMovement.completedAt, preferredLanguage)}</div>
                        </div>
                        <div className="col-12">
                            <label className="block text-500 mb-1">{t('Request Comments')}</label>
                            <div>{selectedMovement.comments || '-'}</div>
                        </div>
                        <div className="col-12">
                            <label className="block text-500 mb-1">{t('Close Comments')}</label>
                            <div>{selectedMovement.completionComments || '-'}</div>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Request Photos')}</label>
                            {normalizePhotoList(selectedMovement.photo, selectedMovement.requestPhotos).length > 0 ? (
                                <div className="grid">
                                    {normalizePhotoList(selectedMovement.photo, selectedMovement.requestPhotos).map((photo, index) => (
                                        <div className="col-6" key={`${selectedMovement._id}-request-photo-${index}`}>
                                            <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '0.35rem' }}>
                                                <img
                                                    src={resolvePhotoUrl(photo) || photo}
                                                    alt={`Request ${index + 1}`}
                                                    style={{ width: '100%', maxHeight: '88px', objectFit: 'cover', borderRadius: '4px', cursor: 'zoom-in' }}
                                                    onClick={() => openPhotoInDialog(photo)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <span className="text-500">{t('No photo')}</span>
                            )}
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block text-500 mb-1">{t('Close Photos')}</label>
                            {normalizePhotoList(selectedMovement.completionPhoto, selectedMovement.completionPhotos).length > 0 ? (
                                <div className="grid">
                                    {normalizePhotoList(selectedMovement.completionPhoto, selectedMovement.completionPhotos).map((photo, index) => (
                                        <div className="col-6" key={`${selectedMovement._id}-close-photo-${index}`}>
                                            <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '0.35rem' }}>
                                                <img
                                                    src={resolvePhotoUrl(photo) || photo}
                                                    alt={`Close ${index + 1}`}
                                                    style={{ width: '100%', maxHeight: '88px', objectFit: 'cover', borderRadius: '4px', cursor: 'zoom-in' }}
                                                    onClick={() => openPhotoInDialog(photo)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <span className="text-500">{t('No photo')}</span>
                            )}
                        </div>
                        <div className="col-12">
                            <label className="block text-500 mb-2">{t('Data Quality Prompts')}</label>
                            {getDataQualityPrompts(selectedMovement).length > 0 ? (
                                <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '8px', padding: '0.75rem' }}>
                                    {getDataQualityPrompts(selectedMovement).map((prompt, idx) => (
                                        <div key={`${selectedMovement._id}-dq-${idx}`} className="mb-1 text-700">
                                            - {prompt}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '8px', padding: '0.75rem' }} className="text-700">
                                    {t('No data quality issues detected.')}
                                </div>
                            )}
                        </div>
                        <div className="col-12">
                            <label className="block text-500 mb-2">{t('Audit Timeline')}</label>
                            <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '0.75rem' }}>
                                {getTimelineEvents(selectedMovement).map((event) => {
                                    const style = getTimelineEventStyle(event.eventType);
                                    return (
                                        <div key={event.id} className="mb-3">
                                            <div className="flex align-items-center gap-2 mb-1">
                                                <span
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        padding: '0.12rem 0.55rem',
                                                        borderRadius: '999px',
                                                        fontSize: '0.72rem',
                                                        fontWeight: 700,
                                                        color: style.color,
                                                        background: style.background
                                                    }}
                                                >
                                                    {event.eventType}
                                                </span>
                                                <span className="text-600 text-sm">{formatLocalizedDateTime(event.at, preferredLanguage)}</span>
                                            </div>
                                            <div className="text-800">{event.message}</div>
                                            <div className="text-500 text-sm">{t('By:')} {event.by || '-'}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="text-500">{t('No movement selected.')}</div>
                )}
            </Dialog>

            <Dialog
                header={t('Movement Checklist')}
                visible={checklistDialogVisible}
                style={{ width: '72rem' }}
                modal
                onHide={() => setChecklistDialogVisible(false)}
                footer={
                    <div className="flex justify-content-end gap-2">
                        {checklistReadOnly && (
                            <span className="text-500 text-sm flex align-items-center">
                                {t('Closed movement checklist is read-only')}
                            </span>
                        )}
                        <Button
                            label={t('Close')}
                            icon="pi pi-times"
                            className="p-button-text"
                            onClick={() => setChecklistDialogVisible(false)}
                        />
                        {!checklistReadOnly && (
                            <Button
                                label={t('Save Checklist')}
                                icon="pi pi-save"
                                className="p-button-primary"
                                loading={checklistSaving}
                                onClick={saveChecklist}
                                disabled={!checklistForm?.checklistData}
                            />
                        )}
                    </div>
                }
            >
                {checklistLoading ? (
                    <div className="text-500">{t('Loading checklist...')}</div>
                ) : !checklistForm?.checklistData ? (
                    <div className="text-500">{t('Checklist not available for this movement.')}</div>
                ) : (
                    <div className="grid p-fluid">
                        <div className="col-12">
                            <div
                                style={{
                                    background: checklistForm.checklistProgress >= 100 ? '#f0fdf4' : '#fffbeb',
                                    border: checklistForm.checklistProgress >= 100 ? '1px solid #86efac' : '1px solid #fde68a',
                                    borderRadius: '8px',
                                    padding: '0.75rem'
                                }}
                            >
                                <div className="flex justify-content-between align-items-center flex-wrap gap-2">
                                    <span className="font-semibold">
                                        {t('Template:')} {checklistForm.checklistTemplateKey || '-'}
                                    </span>
                                    <span className="font-semibold">
                                        {t(CHECKLIST_STATUS_LABELS[checklistForm.checklistStatus] || checklistForm.checklistStatus || 'Pending')} ({checklistForm.checklistProgress}%)
                                    </span>
                                </div>
                                <small className="text-700">
                                    {t('Complete required items to reach 100% and allow movement closure.')}
                                </small>
                            </div>
                        </div>

                        <div className="col-12">
                            <h5 className="mb-2">{t('General Information')}</h5>
                        </div>
                        <div className="col-12 md:col-4">
                            <label className="block mb-2">{t('Location')}</label>
                            <InputText
                                value={checklistForm.checklistData.generalInfo?.location || ''}
                                onChange={(e) => updateChecklistGeneralInfo('location', e.target.value)}
                                className="w-full"
                                disabled={checklistReadOnly}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <label className="block mb-2">{t('Model')}</label>
                            <InputText
                                value={checklistForm.checklistData.generalInfo?.model || ''}
                                onChange={(e) => updateChecklistGeneralInfo('model', e.target.value)}
                                className="w-full"
                                disabled={checklistReadOnly}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <label className="block mb-2">{t('Machine Code')}</label>
                            <InputText
                                value={checklistForm.checklistData.generalInfo?.machineCode || ''}
                                onChange={(e) => updateChecklistGeneralInfo('machineCode', e.target.value)}
                                className="w-full"
                                disabled={checklistReadOnly}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <label className="block mb-2">{t('POS Code')}</label>
                            <InputText
                                value={checklistForm.checklistData.generalInfo?.posCode || ''}
                                onChange={(e) => updateChecklistGeneralInfo('posCode', e.target.value)}
                                className="w-full"
                                disabled={checklistReadOnly}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <label className="block mb-2">{t('Parlevel/Telemetro Code')}</label>
                            <InputText
                                value={checklistForm.checklistData.generalInfo?.parlevelTelemetroCode || ''}
                                onChange={(e) => updateChecklistGeneralInfo('parlevelTelemetroCode', e.target.value)}
                                className="w-full"
                                disabled={checklistReadOnly}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <label className="block mb-2">{t('Technician Name')}</label>
                            <InputText
                                value={checklistForm.checklistData.generalInfo?.technicianName || ''}
                                onChange={(e) => updateChecklistGeneralInfo('technicianName', e.target.value)}
                                className="w-full"
                                disabled={checklistReadOnly}
                            />
                        </div>
                        <div className="col-12 md:col-4">
                            <label className="block mb-2">{t('Date')}</label>
                            <InputText
                                value={checklistForm.checklistData.generalInfo?.date || ''}
                                onChange={(e) => updateChecklistGeneralInfo('date', e.target.value)}
                                placeholder={t('YYYY-MM-DD')}
                                className="w-full"
                                disabled={checklistReadOnly}
                            />
                        </div>

                        {(checklistForm.checklistData.sections || []).map((section) => {
                            const sectionItems = Array.isArray(section?.items) ? section.items : [];
                            const requiredCount = sectionItems.filter((item) => item?.required !== false).length;
                            const completedCount = sectionItems.filter((item) => {
                                if (item?.required === false) return false;
                                return Boolean(normalizeChecklistValue(item?.value));
                            }).length;
                            return (
                                <div className="col-12" key={`${checklistForm.movementId}-${section.sectionKey}`}>
                                    <Card>
                                        <div className="flex justify-content-between align-items-center mb-2">
                                            <h5 className="m-0">{t(section.title)}</h5>
                                            <small className="text-600">
                                                {t('Required completed:')} {completedCount}/{requiredCount}
                                            </small>
                                        </div>
                                        <div className="grid">
                                            {sectionItems.map((item) => (
                                                <div className="col-12" key={`${section.sectionKey}-${item.itemKey}`}>
                                                    <div className="grid align-items-start" style={{ borderBottom: '1px solid #e5e7eb', paddingBottom: '0.75rem', marginBottom: '0.75rem' }}>
                                                        <div className="col-12 md:col-4">
                                                            <label className="block mb-2">
                                                                {t(item.label)} {item.required !== false && <span style={{ color: 'red' }}>*</span>}
                                                            </label>
                                                            <Dropdown
                                                                value={normalizeChecklistValue(item.value)}
                                                                options={checklistItemOptions}
                                                                onChange={(e) => updateChecklistItem(section.sectionKey, item.itemKey, { value: e.value })}
                                                                placeholder={t('Select')}
                                                                className="w-full"
                                                                disabled={checklistReadOnly}
                                                            />
                                                        </div>
                                                        <div className="col-12 md:col-4">
                                                            <label className="block mb-2">{t('Notes')}</label>
                                                            <InputTextarea
                                                                value={item.note || ''}
                                                                onChange={(e) => updateChecklistItem(section.sectionKey, item.itemKey, { note: e.target.value })}
                                                                rows={2}
                                                                autoResize
                                                                className="w-full"
                                                                disabled={checklistReadOnly}
                                                            />
                                                        </div>
                                                        <div className="col-12 md:col-4">
                                                            <PhotoUploader
                                                                label={t('Evidence Photos')}
                                                                value=""
                                                                onChange={(photo) => addChecklistItemPhoto(section.sectionKey, item.itemKey, photo)}
                                                                maxUploadBytes={300 * 1024}
                                                                maxDimension={1280}
                                                                helperText={t('Optional. Up to {0} photos, max 300 KB each.').replace(
                                                                    '{0}',
                                                                    String(MAX_CHECKLIST_ITEM_PHOTOS)
                                                                )}
                                                                disabled={checklistReadOnly}
                                                            />
                                                            {Array.isArray(item.photos) && item.photos.length > 0 && (
                                                                <div className="mt-2 grid">
                                                                    {item.photos.map((photo, photoIndex) => (
                                                                        <div className="col-6" key={`${section.sectionKey}-${item.itemKey}-photo-${photoIndex}`}>
                                                                            <div style={{ border: '1px solid #e5e7eb', borderRadius: '6px', padding: '0.35rem' }}>
                                                                                <img
                                                                                    src={resolvePhotoUrl(photo) || photo}
                                                                                    alt={`Evidence ${photoIndex + 1}`}
                                                                                    style={{ width: '100%', maxHeight: '72px', objectFit: 'cover', borderRadius: '4px', cursor: 'zoom-in' }}
                                                                                    onClick={() => openPhotoInDialog(photo)}
                                                                                />
                                                                                <div className="flex justify-content-end mt-1">
                                                                                    {!checklistReadOnly && (
                                                                                        <Button
                                                                                            type="button"
                                                                                            icon="pi pi-times"
                                                                                            className="p-button-danger p-button-text p-button-sm"
                                                                                            onClick={() => removeChecklistItemPhoto(section.sectionKey, item.itemKey, photoIndex)}
                                                                                            title={t('Remove photo')}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="col-12">
                                                <label className="block mb-2">{t('Section Notes')}</label>
                                                <InputTextarea
                                                    value={section.notes || ''}
                                                    onChange={(e) => updateChecklistSectionNotes(section.sectionKey, e.target.value)}
                                                    rows={2}
                                                    autoResize
                                                    className="w-full"
                                                    disabled={checklistReadOnly}
                                                />
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            );
                        })}
                    </div>
                )}
            </Dialog>

            <Dialog header={t('Movement Photo')} visible={photoDialogVisible} style={{ width: '40rem' }} modal onHide={() => setPhotoDialogVisible(false)}>
                {selectedPhoto && (
                    <>
                        {!selectedPhotoError ? (
                            <img
                                src={selectedPhoto}
                                alt={t('Movement')}
                                style={{ width: '100%', height: 'auto' }}
                                onError={() => setSelectedPhotoError(true)}
                            />
                        ) : (
                            <div className="text-500">{t('Photo failed to load.')}</div>
                        )}
                    </>
                )}
            </Dialog>

            <div className="movement-page-heading">
                <div>
                    <h3>{localText('Machine movements', 'Movimientos de máquinas')}</h3>
                    <p>{localText('Coordinate installations, removals, exchanges, demonstrations and site inspections from one operational view.', 'Coordine instalaciones, retiros, intercambios, demostraciones e inspecciones de sitio desde una sola vista operativa.')}</p>
                </div>
                {createMenuItems.length > 0 && (
                    <div>
                        <Menu model={createMenuItems} popup ref={createMenuRef} id="machine-workflow-create-menu" />
                        <Button
                            label={localText('Create new', 'Crear nuevo')}
                            icon="pi pi-plus"
                            iconPos="left"
                            onClick={(event) => createMenuRef.current?.toggle(event)}
                            aria-haspopup
                            aria-controls="machine-workflow-create-menu"
                        />
                    </div>
                )}
            </div>

            <div className="grid movement-summary-grid">
                {[
                    {
                        label: localText('Pending', 'Pendientes'),
                        value: allPendingRows.length,
                        icon: 'pi pi-clock',
                        tone: 'blue'
                    },
                    {
                        label: localText('Completed', 'Completados'),
                        value: allCompletedRows.length,
                        icon: 'pi pi-check-circle',
                        tone: 'green'
                    },
                    {
                        label: localText('Pending demonstrations', 'Demostraciones pendientes'),
                        value: pendingDemonstrations.length,
                        detail: localText(
                            `Active: ${activeDemonstrations} · Finished: ${completedDemonstrations.length}`,
                            `Activas: ${activeDemonstrations} · Finalizadas: ${completedDemonstrations.length}`
                        ),
                        icon: 'pi pi-star-fill',
                        tone: 'purple'
                    },
                    {
                        label: localText('Pending site inspections', 'Inspecciones de sitio pendientes'),
                        value: pendingSiteInspections.length,
                        detail: localText(
                            `Completed: ${completedSiteInspections.filter((item) => item.inspectionStatus === 'completed').length}`,
                            `Completadas: ${completedSiteInspections.filter((item) => item.inspectionStatus === 'completed').length}`
                        ),
                        icon: 'pi pi-map-marker',
                        tone: 'indigo'
                    },
                    {
                        label: localText('Removals', 'Retiros'),
                        value: churnAnalysis.totalRemovals,
                        icon: 'pi pi-truck',
                        tone: 'red'
                    },
                    {
                        label: localText('Exchanges', 'Intercambios'),
                        value: completedMovements.filter((movement) => movement.movementType.includes('Exchanged')).length,
                        icon: 'pi pi-sync',
                        tone: 'amber'
                    }
                ].map((card) => (
                    <div className="col-12 sm:col-6 xl:col" key={card.label}>
                        <Card className={`movement-summary-card movement-tone-${card.tone}`}>
                            <span className="movement-summary-icon"><i className={card.icon} /></span>
                            <div>
                                <span>{card.label}</span>
                                <strong>{card.value}</strong>
                                {card.detail ? <small>{card.detail}</small> : null}
                            </div>
                        </Card>
                    </div>
                ))}
            </div>

            {churnAnalysis.removalsByReason.length > 0 && (
                <div className="movement-removal-strip">
                    <span><i className="pi pi-chart-bar" /> {localText('Removal reasons', 'Motivos de retiro')}</span>
                    <div>
                        {churnAnalysis.removalsByReason.map((item) => (
                            <span className="movement-removal-badge" key={item.reason}>
                                {item.reason}: {item.count}
                            </span>
                        ))}
                    </div>
                </div>
            )}

            {/* Pending Movements Table */}
            <div className="card movement-list-card mb-4">
                <div className="movement-list-heading">
                    <div>
                        <h4 className="m-0">{t('Pending Movements')}</h4>
                        <small>{localText('Movements, demonstrations and site inspections that still require action.', 'Movimientos, demostraciones e inspecciones de sitio que todavía requieren alguna acción.')}</small>
                    </div>
                    <div className="movement-list-actions">
                        <span className="text-500 text-sm">{pendingTableRows.length} {localText(pendingTableRows.length === 1 ? 'pending record' : 'pending records', pendingTableRows.length === 1 ? 'registro pendiente' : 'registros pendientes')}</span>
                        <Button
                            label={t('Export XLSX')}
                            icon="pi pi-file-excel" 
                            className="p-button-success p-button-sm" 
                            onClick={() => exportPendingMovements('xlsx')}
                            title={t('Export visible pending columns to XLSX')}
                        />
                        <Button
                            label={t('Export CSV')}
                            icon="pi pi-download"
                            className="p-button-outlined p-button-sm"
                            onClick={() => exportPendingMovements('csv')}
                            title={t('Export visible pending columns to CSV')}
                        />
                    </div>
                </div>
                <div className="movement-filter-panel">
                    <div className="grid">
                        <div className="col-12 md:col-3">
                            <label className="block mb-2">{localText('Process type', 'Tipo de proceso')}</label>
                            <Dropdown
                                value={pendingProcessFilter}
                                options={processFilterOptions}
                                onChange={(event) => setPendingProcessFilter(event.value)}
                                className="w-full"
                                disabled={demonstrationsOnly}
                            />
                        </div>
                        <div className="col-12 md:col-3">
                            <label className="block mb-2">{t('Filter by Date - From')}</label>
                            <Calendar 
                                value={pendingDateRange.from} 
                                onChange={(e) => setPendingDateRange({ ...pendingDateRange, from: e.value })} 
                                dateFormat="yy-mm-dd" 
                                placeholder={t('Start date')}
                                showIcon 
                                className="w-full" 
                            />
                        </div>
                        <div className="col-12 md:col-3">
                            <label className="block mb-2">{t('Filter by Date - To')}</label>
                            <Calendar 
                                value={pendingDateRange.to} 
                                onChange={(e) => setPendingDateRange({ ...pendingDateRange, to: e.value })} 
                                dateFormat="yy-mm-dd" 
                                placeholder={t('End date')}
                                showIcon 
                                className="w-full"
                                minDate={pendingDateRange.from}
                            />
                        </div>
                        <div className="col-12 md:col-3 flex align-items-end">
                            <Button 
                                label={t('Clear Filter')}
                                icon="pi pi-times" 
                                className="p-button-secondary w-full" 
                                onClick={() => setPendingDateRange({ from: null, to: null })} 
                            />
                        </div>
                    </div>
                </div>
                <div className="movement-installation-alert-filters" role="group" aria-label={localText('Installation alerts', 'Alertas de instalación')}>
                    {INSTALLATION_ALERT_FILTERS.map((code) => {
                        const meta = INSTALLATION_ALERT_META[code];
                        const label = meta.label[preferredLanguage] || meta.label.en;
                        return (
                            <Button
                                key={code}
                                type="button"
                                label={`${label} (${installationAlertCounts[code] || 0})`}
                                className={`p-button-sm movement-alert-filter movement-alert-filter-${meta.tone} ${
                                    installationAlertFilter === code ? '' : 'p-button-outlined'
                                }`}
                                onClick={() => setInstallationAlertFilter(code)}
                            />
                        );
                    })}
                </div>
                <DataTable className="movement-data-table" value={pendingTableRows} paginator rows={10} rowsPerPageOptions={[5, 10, 20]} emptyMessage={localText('No pending records found.', 'No se encontraron registros pendientes.')} responsiveLayout="scroll" rowClassName={pendingRowClassName}>
                    <Column field="machineType" header={t('Machine Type')} body={(rowData) => t(rowData.machineType || '-')} />
                    <Column field="movementType" header={t('Movement Type')} body={movementTypeBodyTemplate} />
                    <Column header={t('Installation Date')} body={installationDateBodyTemplate} />
                    <Column header={localText('Time and deadline', 'Tiempo y vencimiento')} body={pendingTimeElapsedBodyTemplate} />
                    <Column field="customer" header={t('Customer')} />
                    <Column field="toLocation" header={t('Location')} />
                    <Column field="technician" header={t('Technician')} />
                    <Column header={t('Checklist')} body={checklistStatusBodyTemplate} />
                    <Column
                        header={t('Actions')}
                        body={actionsBodyTemplate}
                        style={{ position: 'sticky', right: 0, background: '#fff', zIndex: 1, minWidth: '6.5rem' }}
                        headerStyle={{ position: 'sticky', right: 0, background: '#fff', zIndex: 2, minWidth: '6.5rem' }}
                    />
                </DataTable>
            </div>

            {/* Completed Movements Table */}
            <div className="card movement-list-card">
                <div className="movement-list-heading">
                    <div>
                        <h4 className="m-0">{t('Completed Movements')}</h4>
                        <small className="text-500">
                            {localText('Filtered by completion. Legacy records without a closing date use confirmed installation or creation date. Default: current month.', 'Filtrado por finalización. Registros antiguos sin cierre: fecha de instalación confirmada o creación. Predeterminado: mes actual.')}
                        </small>
                    </div>
                    <div className="movement-list-actions">
                        <span className="text-500 text-sm">{completedTotalRecords} {localText(completedTotalRecords === 1 ? 'completed record' : 'completed records', completedTotalRecords === 1 ? 'registro completado' : 'registros completados')}</span>
                        <Button
                            label={t('Export XLSX')}
                            icon="pi pi-file-excel" 
                            className="p-button-success p-button-sm" 
                            onClick={() => exportCompletedMovements('xlsx')}
                            title={t('Export visible completed columns to XLSX')}
                        />
                        <Button
                            label={t('Export CSV')}
                            icon="pi pi-download"
                            className="p-button-outlined p-button-sm"
                            onClick={() => exportCompletedMovements('csv')}
                            title={t('Export visible completed columns to CSV')}
                        />
                    </div>
                </div>
                <div className="movement-filter-panel">
                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <label htmlFor="completed-movement-customers" className="block mb-2">{t('Customer')}</label>
                            <MultiSelect
                                inputId="completed-movement-customers"
                                value={completedCustomers}
                                options={completedCustomerOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={(event) => {
                                    setCompletedCustomers(event.value || []);
                                    resetCompletedPage();
                                }}
                                placeholder={localText('All customers', 'Todos los clientes')}
                                emptyMessage={localText('No customers available', 'No hay clientes disponibles')}
                                emptyFilterMessage={localText('No customers found', 'No se encontraron clientes')}
                                filter
                                showClear
                                display="chip"
                                maxSelectedLabels={3}
                                className="w-full"
                            />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="completed-movement-search" className="block mb-2">{localText('Search completed records', 'Buscar registros completados')}</label>
                            <InputText
                                id="completed-movement-search"
                                value={completedSearch}
                                onChange={(event) => {
                                    setCompletedSearch(event.target.value);
                                    resetCompletedPage();
                                }}
                                placeholder={localText('Machine, customer, location or technician', 'Máquina, cliente, ubicación o técnico')}
                                className="w-full"
                            />
                        </div>
                        <div className="col-12 md:col-3">
                            <label className="block mb-2">{localText('Process type', 'Tipo de proceso')}</label>
                            <Dropdown
                                value={completedProcessFilter}
                                options={processFilterOptions}
                                onChange={(event) => {
                                    setCompletedProcessFilter(event.value);
                                    setCompletedPagination((current) => ({ ...current, first: 0, page: 1 }));
                                }}
                                className="w-full"
                                disabled={demonstrationsOnly}
                            />
                        </div>
                        <div className="col-12 md:col-3">
                            <label className="block mb-2">{localText('Completion date - From', 'Fecha de finalización - Desde')}</label>
                            <Calendar 
                                value={installedDateRange.from} 
                                onChange={(e) => updateInstalledDateRange({ from: e.value })}
                                dateFormat="yy-mm-dd" 
                                placeholder={t('Start date')}
                                showIcon 
                                className="w-full" 
                            />
                        </div>
                        <div className="col-12 md:col-3">
                            <label className="block mb-2">{localText('Completion date - To', 'Fecha de finalización - Hasta')}</label>
                            <Calendar 
                                value={installedDateRange.to} 
                                onChange={(e) => updateInstalledDateRange({ to: e.value })}
                                dateFormat="yy-mm-dd" 
                                placeholder={t('End date')}
                                showIcon 
                                className="w-full"
                                minDate={installedDateRange.from}
                            />
                        </div>
                        <div className="col-12 md:col-3 flex align-items-end">
                            <Button 
                                label={localText('Clear filters', 'Limpiar filtros')}
                                icon="pi pi-times" 
                                className="p-button-secondary w-full" 
                                onClick={() => {
                                    setCompletedCustomers([]);
                                    setCompletedSearch('');
                                    setCompletedProcessFilter(demonstrationsOnly ? 'demonstrations' : 'all');
                                    updateInstalledDateRange({ from: null, to: null });
                                }}
                            />
                        </div>
                    </div>
                </div>
                <DataTable
                    className="movement-data-table"
                    value={completedTableRows}
                    paginator
                    first={completedPagination.first}
                    rows={completedPagination.rows}
                    rowsPerPageOptions={[10, 25, 50]}
                    onPage={onCompletedPage}
                    emptyMessage={localText('No completed records found.', 'No se encontraron registros completados.')}
                    responsiveLayout="scroll"
                    rowClassName={(rowData) => isDemonstrationWorkflow(rowData) ? 'movement-demonstration-row' : isSiteInspectionWorkflow(rowData) ? 'movement-site-inspection-row' : ''}
                >
                    <Column field="machineId" header={t('Machine ID')} />
                    <Column field="machineType" header={t('Machine Type')} body={(rowData) => t(rowData.machineType || '-')} />
                    <Column field="movementType" header={t('Movement Type')} body={movementTypeBodyTemplate} />
                    <Column header={t('Installation Date')} body={(rowData) => formatInstallationDateLabel(rowData.installationDateFrom, rowData.installationDateTo, preferredLanguage)} />
                    <Column field="date" header={t('Date')} />
                    <Column field="customer" header={t('Customer')} />
                    <Column field="toLocation" header={t('Location')} />
                    <Column field="technician" header={t('Technician')} />
                    <Column header={t('Close Comments')} body={closeCommentsBodyTemplate} />
                    <Column field="completedBy" header={t('Completed By')} />
                    <Column header={t('Completed At')} body={completedAtBodyTemplate} />
                    <Column header={t('Actions')} body={actionsBodyTemplate} />
                </DataTable>
            </div>

            <MachineDemonstrations
                ref={demonstrationControllerRef}
                integrated
                onChanged={loadDemonstrationWorkflows}
            />
            {!demonstrationsOnly && (
                <SiteInspectionDialog
                    ref={siteInspectionControllerRef}
                    technicians={technicians}
                    currentAdmin={currentAdmin}
                    onChanged={loadSiteInspectionWorkflows}
                    onCreateInstallation={openInstallationFromInspection}
                />
            )}
        </div>
    );
};

export default MachineMovementReport;
